export default {
    zh: {
        // 页面标题和描述
        pageTitle: 'Google Veo 3 AI 视频生成器 - 免费体验革命性 AI 视频创作工具',
        pageDescription: '体验 Google Veo 3 AI 视频生成器，支持原生音频生成、参考视频、相机控制等核心功能。在 WeryAI 平台免费试用，创造专业级 AI 视频内容。',
        pageKeywords: 'Veo 3, Google AI 视频生成器, AI 视频创作, 人工智能视频, 视频生成工具, 免费 AI 视频, WeryAI, 视频制作',

        // 生成器部分
        generatorTitle: 'Google Veo 3 AI 视频生成器',
        generatorDescription: 'WeryAI 现已深度集成Veo 3模型，能够生成高质量、逼真自然的音频视频。它于<span class="highlight-red">2025 年 5 月</span>在 Google I/O 2025 大会上发布，并在质量上比其前代产品<span class="highlight-red">Veo 2</span>有了显著提升。快来<span class="highlight-red">WeryAI 视频生成器免费体验 Veo 3</span>！',
        
        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Veo 3 核心功能特性',
        coreFeaturesSubtitle: '探索 Google Veo 3 AI 视频生成器的核心功能，开启革命性的 AI 视频创作之旅',

        // 原生音频生成功能
        nativeAudioTitle: '原生音频生成',
        nativeAudioDescription: 'Veo 3 创建音频并将其集成到生成的视频中，实现完美的视听同步体验，让您的视频更具吸引力和真实感。',

        // 参考视频和一致角色功能
        referenceVideoTitle: '参考视频和一致角色',
        referenceVideoDescription: '基于参考材料创建角色一致的视频，确保角色外观和特征在不同场景中的高度一致性。',

        // 相机控制功能
        cameraControlTitle: '相机控制',
        cameraControlDescription: '创建具有特定相机运动效果的视频，支持推拉、平移、倾斜等专业镜头运动，营造电影级视觉效果。',

        // 病毒式内容创作功能
        viralContentTitle: '制作易于病毒式传播的内容',
        viralContentDescription: '创作有趣的"假新闻"视频或时空穿越短片，帮助你赢得点赞，在社交媒体上轻松引爆流量。',

        // 高级提示理解功能
        advancedPromptTitle: '高级提示理解',
        advancedPromptDescription: '高精度地解读复杂提示词，准确理解您的创意意图，将文字描述转化为生动的视觉画面。',

        // 精确样式控制功能
        preciseStyleControlTitle: '精确样式控制',
        preciseStyleControlDescription: '根据参考图像控制艺术风格，实现精准的视觉风格定制，让您的创意完美呈现。',

        // 首帧和尾帧功能
        firstLastFrameTitle: '首帧和尾帧',
        firstLastFrameDescription: '生成两张上传图片之间的无缝视频，实现精准的场景过渡和流畅的视觉衔接。',

        // 添加和移除对象功能
        addRemoveObjectsTitle: '添加和移除对象',
        addRemoveObjectsDescription: '在视频场景中添加或删除物体，实现灵活的场景编辑和创意表达。',

        // 灵活运动控制功能
        flexibleMotionControlTitle: '灵活运动控制',
        flexibleMotionControlDescription: '自定义视频对象的运动轨迹，精确控制每个元素的动画表现，创造独特的动态效果。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',
        step1Title: '选择模型',
        step1Description: '在 AI 视频工具中选择 Veo 3 模型',
        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',
        step3Title: '生成视频',
        step3Description: '点击生成按钮，等待并下载您的视频',

        // YouTube 视频部分
        youtubeTitle: 'Google Veo 3 AI 视频模型相关 YouTube 视频',
        youtubeVideosTitle: 'Google Veo 3 AI 视频模型相关 YouTube 视频',
        youtubeVideoTitle: 'Google Veo 3 AI 视频模型相关 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Veo 3 的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他视频模型',
        veoModelsTitle: 'Google Veo Models',
        veo2Title: 'Google Veo 2 AI 视频生成器',
        veo31Title: 'Google Veo 3.1 视频生成器',
        veo3FastTitle: 'Google Veo 3 Fast AI 视频生成器',
        sora2Title: 'OpenAI Sora-2 AI视频生成器',
        klingTitle: 'kling 2.5 视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaSubtitle: '立即体验 Veo 3，将您的创意转化为精彩视频',
        ctaDescription: '立即体验 Veo 3，将您的创意转化为精彩视频',
        ctaButton: '在WeryAI上试用Veo 3',
        ctaNote: '无需信用卡',
        ctaDisclaimer: '无需信用卡',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoUnsupported: '您的浏览器不支持视频播放',
        videoLoadingError: '视频加载失败',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
    },
    en: {
        // Page title and description
        pageTitle: 'Google Veo 3 AI Video Generator - Free Revolutionary AI Video Creation Tool',
        pageDescription: 'Experience Google Veo 3 AI video generator with native audio generation, reference video, camera control and core features. Try it free on WeryAI platform and create professional AI video content.',
        pageKeywords: 'Veo 3, Google AI video generator, AI video creation, artificial intelligence video, video generation tool, free AI video, WeryAI, video production',

        // Generator section
        generatorTitle: 'Google Veo 3 AI Video Generator',
        generatorDescription: 'WeryAI now deeply integrates the Veo 3 model, realistic audio-video content. Released in May 2025 at Google I/O 2025, it represents a significant improvement over its predecessor Veo 2. Try Veo 3 for free on WeryAI video generator!',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Veo 3 Core Features',
        coreFeaturesSubtitle: 'Explore the core features of Google Veo 3 AI video generator and embark on a revolutionary AI video creation journey',

        // Native audio generation feature
        nativeAudioTitle: 'Native Audio Generation',
        nativeAudioDescription: 'Veo 3 creates audio and integrates it into the videos it produces, achieving perfect audiovisual synchronization experience, making your videos more engaging and realistic.',

        // Reference video and consistent characters feature
        referenceVideoTitle: 'Reference Video and Consistent Characters',
        referenceVideoDescription: 'Create character-consistent videos based on reference materials, ensuring high consistency of character appearance and characteristics across different scenes.',

        // Camera control feature
        cameraControlTitle: 'Camera Control',
        cameraControlDescription: 'Create videos with specific camera movement effects, supporting professional lens movements like push, pull, pan, and tilt to create cinematic visual effects.',

        // Viral content creation feature
        viralContentTitle: 'Viral Content Creation',
        viralContentDescription: 'Create engaging "fake news" videos or time-travel shorts to help you win likes and easily go viral on social media.',

        // Advanced prompt understanding feature
        advancedPromptTitle: 'Advanced Prompt Understanding',
        advancedPromptDescription: 'Accurately interpret complex prompts, precisely understand your creative intentions, and transform text descriptions into vivid visual scenes.',

        // Precise style control feature
        preciseStyleControlTitle: 'Precise Style Control',
        preciseStyleControlDescription: 'Control artistic style based on reference images, achieving precise visual style customization to perfectly present your creativity.',

        // First and last frame feature
        firstLastFrameTitle: 'First and Last Frame',
        firstLastFrameDescription: 'Generate seamless videos between two uploaded images, achieving precise scene transitions and smooth visual connections.',

        // Add and remove objects feature
        addRemoveObjectsTitle: 'Add and Remove Objects',
        addRemoveObjectsDescription: 'Add or remove objects in video scenes, enabling flexible scene editing and creative expression.',

        // Flexible motion control feature
        flexibleMotionControlTitle: 'Flexible Motion Control',
        flexibleMotionControlDescription: 'Customize motion trajectories of video objects, precisely control animation performance of each element, creating unique dynamic effects.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose Veo 3 model in AI video tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Video',
        step3Description: 'Click generate button, wait and download your video',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos on Google Veo 3 AI Video Model',
        youtubeVideosTitle: 'YouTube Videos on Google Veo 3 AI Video Model',
        youtubeVideoTitle: 'YouTube Videos on Google Veo 3 AI Video Model',

        // X Posts section
        xPostsTitle: 'X Posts About Veo 3 AI Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        veoModelsTitle: 'Google Veo Models',
        veo2Title: 'Google Veo 2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        klingTitle: 'kling 2.5 Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaSubtitle: 'Experience Veo 3 now and transform your creativity into amazing videos',
        ctaDescription: 'Experience Veo 3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Veo 3 on WeryAI',
        ctaNote: 'No credit card required',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoUnsupported: 'Your browser does not support video playback',
        videoLoadingError: 'Video loading failed',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
    },
    ja: {
        // ページタイトルと説明
        pageTitle: 'Google Veo 3 AI動画ジェネレーター - 無料で革命的なAI動画作成ツールを体験',
        pageDescription: 'Google Veo 3 AI動画ジェネレーターを体験。ネイティブ音声生成、参照動画、カメラ制御などコア機能をサポート。WeryAIプラットフォームで無料試用し、プロフェッショナルなAI動画コンテンツを作成。',
        pageKeywords: 'Veo 3, Google AI動画ジェネレーター, AI動画作成, 人工知能動画, 動画生成ツール, 無料AI動画, WeryAI, 動画制作',

        // ジェネレーター部分
        generatorTitle: 'Google Veo 3 AI動画ジェネレーター',
        generatorDescription: 'WeryAI はVeo 3モデルを深く統合し、2025年5月のGoogle I/O 2025でリリースされ、前世代のVeo 2と比較して大幅な改善を実現しています。WeryAI動画ジェネレーターでVeo 3を無料でお試しください！',
        
        // タブ
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',

        // コア機能部分
        coreFeaturesTitle: 'Veo 3 コア機能',
        coreFeaturesSubtitle: 'Google Veo 3 AI動画ジェネレーターのコア機能を探索し、革命的なAI動画作成の旅を始めましょう',

        // ネイティブ音声生成機能
        nativeAudioTitle: 'ネイティブ音声生成',
        nativeAudioDescription: 'Veo 3は音声を作成し、生成する動画に統合し、完璧な音響視覚同期体験を実現し、動画をより魅力的でリアルにします。',

        // 参照動画と一貫したキャラクター機能
        referenceVideoTitle: '参照動画と一貫したキャラクター',
        referenceVideoDescription: '参照資料に基づいてキャラクター一貫性のある動画を作成し、異なるシーン間でキャラクターの外観と特徴の高い一貫性を確保します。',

        // カメラ制御機能
        cameraControlTitle: 'カメラ制御',
        cameraControlDescription: '特定のカメラ移動効果を持つ動画を作成し、プッシュ、プル、パン、チルトなどのプロフェッショナルなレンズ移動をサポートし、映画的な視覚効果を作り出します。',

        // バイラルコンテンツ作成機能
        viralContentTitle: 'バイラルコンテンツ作成',
        viralContentDescription: '魅力的な「フェイクニュース」動画やタイムトラベルショートを作成し、いいねを獲得し、ソーシャルメディアで簡単にバイラル化を実現します。',

        // 高度なプロンプト理解機能
        advancedPromptTitle: '高度なプロンプト理解',
        advancedPromptDescription: '複雑なプロンプトを正確に解釈し、創造的な意図を正確に理解し、テキスト記述を鮮明な視覚シーンに変換します。',

        // 精密スタイル制御機能
        preciseStyleControlTitle: '精密スタイル制御',
        preciseStyleControlDescription: '参照画像に基づいて芸術スタイルを制御し、精密な視覚スタイルのカスタマイズを実現し、あなたの創造性を完璧に表現します。',

        // 最初と最後のフレーム機能
        firstLastFrameTitle: '最初と最後のフレーム',
        firstLastFrameDescription: '2つのアップロード画像の間のシームレスな動画を生成し、精密なシーン遷移とスムーズな視覚接続を実現します。',

        // オブジェクトの追加と削除機能
        addRemoveObjectsTitle: 'オブジェクトの追加と削除',
        addRemoveObjectsDescription: '動画シーンでオブジェクトを追加または削除し、柔軟なシーン編集と創造的な表現を可能にします。',

        // 柔軟なモーション制御機能
        flexibleMotionControlTitle: '柔軟なモーション制御',
        flexibleMotionControlDescription: '動画オブジェクトのモーショントラジェクトリをカスタマイズし、各要素のアニメーション性能を精密に制御し、独自の動的効果を作成します。',

        // 使用方法部分
        howToUseTitle: '使用方法',
        howToUseSubtitle: '簡単3ステップで開始',
        step1Title: 'モデル選択',
        step1Description: 'AI動画ツールでVeo 3モデルを選択',
        step2Title: 'コンテンツ入力',
        step2Description: 'プロンプトを入力または参照画像をアップロード',
        step3Title: '動画生成',
        step3Description: '生成ボタンをクリックし、待機して動画をダウンロード',

        // YouTube動画部分
        youtubeTitle: 'Google Veo 3 AI動画モデルに関するYouTube動画',
        youtubeVideosTitle: 'Google Veo 3 AI動画モデルに関するYouTube動画',
        youtubeVideoTitle: 'Google Veo 3 AI動画モデルに関するYouTube動画',

        // X投稿部分
        xPostsTitle: 'Veo 3 AI動画モデルに関するX投稿',

        // 他のモデル探索部分
        exploreModelsTitle: '他の動画モデルを探索',
        veoModelsTitle: 'Google Veo Models',
        veo2Title: 'Google Veo 2 AI動画ジェネレーター',
        veo31Title: 'Google Veo 3.1 AI動画ジェネレーター',
        veo3FastTitle: 'Google Veo 3 Fast AI動画ジェネレーター',
        sora2Title: 'OpenAI Sora-2 AI動画ジェネレーター',
        klingTitle: 'kling 2.5動画ジェネレーター',

        // FAQ部分
        faqTitle: 'よくある質問',

        // CTA部分
        ctaTitle: '作成を始める準備はできましたか？',
        ctaSubtitle: '今すぐVeo 3を体験し、あなたの創造性を素晴らしい動画に変換',
        ctaDescription: '今すぐVeo 3を体験し、あなたの創造性を素晴らしい動画に変換',
        ctaButton: 'WeryAIでVeo 3を試す',
        ctaNote: 'クレジットカード不要',
        ctaDisclaimer: 'クレジットカード不要',

        // 動画再生関連
        videoNotSupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoUnsupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoLoadingError: '動画の読み込みに失敗しました',
        videoLoadError: '動画の読み込みに失敗しました',
        videoReload: '再読み込み',
    },
    ko: {
        // 페이지 제목과 설명
        pageTitle: 'Google Veo 3 AI 비디오 생성기 - 무료로 혁신적인 AI 비디오 제작 도구 체험',
        pageDescription: 'Google Veo 3 AI 비디오 생성기를 체험하세요. 네이티브 오디오 생성, 참조 비디오, 카메라 제어 등 핵심 기능을 지원합니다. WeryAI 플랫폼에서 무료로 체험하고 전문적인 AI 비디오 콘텐츠를 만드세요.',
        pageKeywords: 'Veo 3, Google AI 비디오 생성기, AI 비디오 제작, 인공지능 비디오, 비디오 생성 도구, 무료 AI 비디오, WeryAI, 비디오 제작',

        // 생성기 부분
        generatorTitle: 'Google Veo 3 AI 비디오 생성기',
        generatorDescription: 'WeryAI는 이제 Veo 3 모델을 심층 통합하여, 2025년 5월 Google I/O 2025에서 출시되었으며, 전작인 Veo 2에 비해 상당한 개선을 보여줍니다. WeryAI 비디오 생성기에서 Veo 3을 무료로 체험해보세요!',
        
        // 탭
        tabImageToVideo: '이미지에서 비디오',
        tabTextToVideo: '텍스트에서 비디오',

        // 핵심 기능 부분
        coreFeaturesTitle: 'Veo 3 핵심 기능',
        coreFeaturesSubtitle: 'Google Veo 3 AI 비디오 생성기의 핵심 기능을 탐색하고 혁신적인 AI 비디오 제작 여정을 시작하세요',

        // 네이티브 오디오 생성 기능
        nativeAudioTitle: '네이티브 오디오 생성',
        nativeAudioDescription: 'Veo 3은 오디오를 생성하고 생성하는 비디오에 통합하여 완벽한 오디오비주얼 동기화 경험을 달성하고 비디오를 더욱 매력적이고 현실적으로 만듭니다.',

        // 참조 비디오와 일관된 캐릭터 기능
        referenceVideoTitle: '참조 비디오와 일관된 캐릭터',
        referenceVideoDescription: '참조 자료를 기반으로 캐릭터 일관성 있는 비디오를 생성하여 서로 다른 장면에서 캐릭터의 외관과 특성의 높은 일관성을 보장합니다.',

        // 카메라 제어 기능
        cameraControlTitle: '카메라 제어',
        cameraControlDescription: '특정 카메라 이동 효과가 있는 비디오를 생성하고, 푸시, 풀, 팬, 틸트 등의 전문적인 렌즈 이동을 지원하여 영화적인 시각 효과를 만듭니다.',

        // 바이럴 콘텐츠 생성 기능
        viralContentTitle: '바이럴 콘텐츠 생성',
        viralContentDescription: '매력적인 "가짜 뉴스" 비디오나 시간 여행 단편을 생성하여 좋아요를 얻고 소셜 미디어에서 쉽게 바이럴화를 달성합니다.',

        // 고급 프롬프트 이해 기능
        advancedPromptTitle: '고급 프롬프트 이해',
        advancedPromptDescription: '복잡한 프롬프트를 정확하게 해석하고 창의적인 의도를 정확히 이해하며 텍스트 설명을 생생한 시각적 장면으로 변환합니다.',

        // 정밀 스타일 제어 기능
        preciseStyleControlTitle: '정밀 스타일 제어',
        preciseStyleControlDescription: '참조 이미지를 기반으로 예술적 스타일을 제어하여 정밀한 시각적 스타일 사용자 정의를 달성하고 창의성을 완벽하게 표현합니다.',

        // 첫 번째 및 마지막 프레임 기능
        firstLastFrameTitle: '첫 번째 및 마지막 프레임',
        firstLastFrameDescription: '업로드된 두 이미지 사이의 원활한 비디오를 생성하여 정밀한 장면 전환과 부드러운 시각적 연결을 달성합니다.',

        // 객체 추가 및 제거 기능
        addRemoveObjectsTitle: '객체 추가 및 제거',
        addRemoveObjectsDescription: '비디오 장면에서 객체를 추가하거나 제거하여 유연한 장면 편집과 창의적 표현을 가능하게 합니다.',

        // 유연한 모션 제어 기능
        flexibleMotionControlTitle: '유연한 모션 제어',
        flexibleMotionControlDescription: '비디오 객체의 모션 궤적을 사용자 정의하고 각 요소의 애니메이션 성능을 정확하게 제어하여 고유한 동적 효과를 만듭니다.',

        // 사용 방법 부분
        howToUseTitle: '사용 방법',
        howToUseSubtitle: '간단한 3단계로 시작',
        step1Title: '모델 선택',
        step1Description: 'AI 비디오 도구에서 Veo 3 모델 선택',
        step2Title: '콘텐츠 입력',
        step2Description: '프롬프트 입력 또는 참조 이미지 업로드',
        step3Title: '비디오 생성',
        step3Description: '생성 버튼 클릭, 대기 후 비디오 다운로드',

        // YouTube 비디오 부분
        youtubeTitle: 'Google Veo 3 AI 비디오 모델에 대한 YouTube 비디오',
        youtubeVideosTitle: 'Google Veo 3 AI 비디오 모델에 대한 YouTube 비디오',
        youtubeVideoTitle: 'Google Veo 3 AI 비디오 모델에 대한 YouTube 비디오',

        // X 게시물 부분
        xPostsTitle: 'Veo 3 AI 비디오 모델에 대한 X 게시물',

        // 다른 모델 탐색 부분
        exploreModelsTitle: '다른 비디오 모델 탐색',
        veoModelsTitle: 'Google Veo Models',
        veo2Title: 'Google Veo 2 AI 비디오 생성기',
        veo31Title: 'Google Veo 3.1 AI 비디오 생성기',
        veo3FastTitle: 'Google Veo 3 Fast AI 비디오 생성기',
        sora2Title: 'OpenAI Sora-2 AI 비디오 생성기',
        klingTitle: 'kling 2.5 비디오 생성기',

        // FAQ 부분
        faqTitle: '자주 묻는 질문',

        // CTA 부분
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaSubtitle: '지금 Veo 3을 체험하고 당신의 창의성을 놀라운 비디오로 변환하세요',
        ctaDescription: '지금 Veo 3을 체험하고 당신의 창의성을 놀라운 비디오로 변환하세요',
        ctaButton: 'WeryAI에서 Veo 3 체험하기',
        ctaNote: '신용카드 불필요',
        ctaDisclaimer: '신용카드 불필요',

        // 비디오 재생 관련
        videoNotSupported: '귀하의 브라우저는 비디오 재생을 지원하지 않습니다',
        videoUnsupported: '귀하의 브라우저는 비디오 재생을 지원하지 않습니다',
        videoLoadingError: '비디오 로딩 실패',
        videoLoadError: '비디오 로딩 실패',
        videoReload: '다시 로드',
    },
    tw: {

        // 页面标题和描述
        pageTitle: 'Google Veo 3 AI 视频生成器 - 免费体验革命性 AI 视频创作工具',
        pageDescription: '体验 Google Veo 3 AI 视频生成器，支持原生音频生成、参考视频、相机控制等核心功能。在 WeryAI 平台免费试用，创造专业级 AI 视频内容。',
        pageKeywords: 'Veo 3, Google AI 视频生成器, AI 视频创作, 人工智能视频, 视频生成工具, 免费 AI 视频, WeryAI, 视频制作',

        // 生成器部分
        generatorTitle: 'Google Veo 3 AI 视频生成器',
        generatorDescription: 'WeryAI 現已深度整合Veo 3模型，能够生成高质量、逼真自然的音频视频。它于<span class="highlight-red">2025 年 5 月</span>在 Google I/O 2025 大会上发布，并在质量上比其前代产品<span class="highlight-red">Veo 2</span>有了显著提升。快来<span class="highlight-red">WeryAI 视频生成器免费体验 Veo 3</span>！',
        
        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Veo 3 核心功能特性',
        coreFeaturesSubtitle: '探索 Google Veo 3 AI 视频生成器的核心功能，开启革命性的 AI 视频创作之旅',

        // 原生音频生成功能
        nativeAudioTitle: '原生音频生成',
        nativeAudioDescription: 'Veo 3 创建音频并将其集成到生成的视频中，实现完美的视听同步体验，让您的视频更具吸引力和真实感。',

        // 参考视频和一致角色功能
        referenceVideoTitle: '参考视频和一致角色',
        referenceVideoDescription: '基于参考材料创建角色一致的视频，确保角色外观和特征在不同场景中的高度一致性。',

        // 相机控制功能
        cameraControlTitle: '相机控制',
        cameraControlDescription: '创建具有特定相机运动效果的视频，支持推拉、平移、倾斜等专业镜头运动，营造电影级视觉效果。',

        // 病毒式内容创作功能
        viralContentTitle: '制作易于病毒式传播的内容',
        viralContentDescription: '创作有趣的"假新闻"视频或时空穿越短片，帮助你赢得点赞，在社交媒体上轻松引爆流量。',

        // 高级提示理解功能
        advancedPromptTitle: '高级提示理解',
        advancedPromptDescription: '高精度地解读复杂提示词，准确理解您的创意意图，将文字描述转化为生动的视觉画面。',

        // 精确样式控制功能
        preciseStyleControlTitle: '精确样式控制',
        preciseStyleControlDescription: '根据参考图像控制艺术风格，实现精准的视觉风格定制，让您的创意完美呈现。',

        // 首帧和尾帧功能
        firstLastFrameTitle: '首帧和尾帧',
        firstLastFrameDescription: '生成两张上传图片之间的无缝视频，实现精准的场景过渡和流畅的视觉衔接。',

        // 添加和移除对象功能
        addRemoveObjectsTitle: '添加和移除对象',
        addRemoveObjectsDescription: '在视频场景中添加或删除物体，实现灵活的场景编辑和创意表达。',

        // 灵活运动控制功能
        flexibleMotionControlTitle: '灵活运动控制',
        flexibleMotionControlDescription: '自定义视频对象的运动轨迹，精确控制每个元素的动画表现，创造独特的动态效果。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',
        step1Title: '选择模型',
        step1Description: '在 AI 视频工具中选择 Veo 3 模型',
        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',
        step3Title: '生成视频',
        step3Description: '点击生成按钮，等待并下载您的视频',

        // YouTube 视频部分
        youtubeTitle: 'Google Veo 3 AI 视频模型相关 YouTube 视频',
        youtubeVideosTitle: 'Google Veo 3 AI 视频模型相关 YouTube 视频',
        youtubeVideoTitle: 'Google Veo 3 AI 视频模型相关 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Veo 3 的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他视频模型',
        veoModelsTitle: 'Google Veo Models',
        veo2Title: 'Google Veo 2 AI 视频生成器',
        veo31Title: 'Google Veo 3.1 视频生成器',
        veo3FastTitle: 'Google Veo 3 Fast AI 视频生成器',
        sora2Title: 'OpenAI Sora-2 AI视频生成器',
        klingTitle: 'kling 2.5 视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaSubtitle: '立即体验 Veo 3，将您的创意转化为精彩视频',
        ctaDescription: '立即体验 Veo 3，将您的创意转化为精彩视频',
        ctaButton: '在WeryAI上试用Veo 3',
        ctaNote: '无需信用卡',
        ctaDisclaimer: '无需信用卡',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoUnsupported: '您的浏览器不支持视频播放',
        videoLoadingError: '视频加载失败',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
    },
    pl: {

        // Page title and description
        pageTitle: 'Google Veo 3 AI Video Generator - Free Revolutionary AI Video Creation Tool',
        pageDescription: 'Experience Google Veo 3 AI video generator with native audio generation, reference video, camera control and core features. Try it free on WeryAI platform and create professional AI video content.',
        pageKeywords: 'Veo 3, Google AI video generator, AI video creation, artificial intelligence video, video generation tool, free AI video, WeryAI, video production',

        // Generator section
        generatorTitle: 'Google Veo 3 AI Video Generator',
        generatorDescription: 'WeryAI jest teraz głęboko zintegrowane z modelem Veo 3, realistic audio-video content. Released in May 2025 at Google I/O 2025, it represents a significant improvement over its predecessor Veo 2. Try Veo 3 for free on WeryAI video generator!',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Veo 3 Core Features',
        coreFeaturesSubtitle: 'Explore the core features of Google Veo 3 AI video generator and embark on a revolutionary AI video creation journey',

        // Native audio generation feature
        nativeAudioTitle: 'Native Audio Generation',
        nativeAudioDescription: 'Veo 3 creates audio and integrates it into the videos it produces, achieving perfect audiovisual synchronization experience, making your videos more engaging and realistic.',

        // Reference video and consistent characters feature
        referenceVideoTitle: 'Reference Video and Consistent Characters',
        referenceVideoDescription: 'Create character-consistent videos based on reference materials, ensuring high consistency of character appearance and characteristics across different scenes.',

        // Camera control feature
        cameraControlTitle: 'Camera Control',
        cameraControlDescription: 'Create videos with specific camera movement effects, supporting professional lens movements like push, pull, pan, and tilt to create cinematic visual effects.',

        // Viral content creation feature
        viralContentTitle: 'Viral Content Creation',
        viralContentDescription: 'Create engaging "fake news" videos or time-travel shorts to help you win likes and easily go viral on social media.',

        // Advanced prompt understanding feature
        advancedPromptTitle: 'Advanced Prompt Understanding',
        advancedPromptDescription: 'Accurately interpret complex prompts, precisely understand your creative intentions, and transform text descriptions into vivid visual scenes.',

        // Precise style control feature
        preciseStyleControlTitle: 'Precise Style Control',
        preciseStyleControlDescription: 'Control artistic style based on reference images, achieving precise visual style customization to perfectly present your creativity.',

        // First and last frame feature
        firstLastFrameTitle: 'First and Last Frame',
        firstLastFrameDescription: 'Generate seamless videos between two uploaded images, achieving precise scene transitions and smooth visual connections.',

        // Add and remove objects feature
        addRemoveObjectsTitle: 'Add and Remove Objects',
        addRemoveObjectsDescription: 'Add or remove objects in video scenes, enabling flexible scene editing and creative expression.',

        // Flexible motion control feature
        flexibleMotionControlTitle: 'Flexible Motion Control',
        flexibleMotionControlDescription: 'Customize motion trajectories of video objects, precisely control animation performance of each element, creating unique dynamic effects.',

        // How to use section
        howToUseTitle: 'Jak używać',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose Veo 3 model in AI video tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Video',
        step3Description: 'Click generate button, wait and download your video',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos on Google Veo 3 AI Video Model',
        youtubeVideosTitle: 'YouTube Videos on Google Veo 3 AI Video Model',
        youtubeVideoTitle: 'YouTube Videos on Google Veo 3 AI Video Model',

        // X Posts section
        xPostsTitle: 'X Posts About Veo 3 AI Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        veoModelsTitle: 'Google Veo Models',
        veo2Title: 'Google Veo 2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        klingTitle: 'kling 2.5 Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaSubtitle: 'Experience Veo 3 now and transform your creativity into amazing videos',
        ctaDescription: 'Experience Veo 3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Veo 3 on WeryAI',
        ctaNote: 'No credit card required',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoUnsupported: 'Your browser does not support video playback',
        videoLoadingError: 'Video loading failed',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
    },
    es: {
        // Título y descripción de la página
        pageTitle: 'Generador de Video AI Google Veo 3 - Herramienta Revolucionaria de Creación de Videos AI Gratis | WeryAI',
        pageDescription: 'Experimenta el generador de video AI Google Veo 3 con generación de audio nativo, video de referencia, control de cámara y funciones principales. Pruébalo gratis en la plataforma WeryAI y crea contenido de video AI profesional.',
        pageKeywords: 'Veo 3, generador de video AI Google, creación de video AI, video de inteligencia artificial, herramienta de generación de video, video AI gratis, WeryAI, producción de video',

        // Sección del generador
        generatorTitle: 'Generador de Video AI Google Veo 3',
        generatorDescription: 'WeryAI ahora integra profundamente el modelo Veo 3, Lanzado en mayo de 2025 en Google I/O 2025, representa una mejora significativa sobre su predecesor Veo 2. ¡Prueba Veo 3 gratis en el generador de video de WeryAI!',
        
        // Pestañas
        tabImageToVideo: 'Imagen a Video',
        tabTextToVideo: 'Texto a Video',

        // Sección de características principales
        coreFeaturesTitle: 'Características Principales de Veo 3',
        coreFeaturesSubtitle: 'Explora las características principales del generador de video AI Google Veo 3 y emprende un viaje revolucionario de creación de video AI',

        // Función de generación de audio nativo
        nativeAudioTitle: 'Generación de Audio Nativo',
        nativeAudioDescription: 'Veo 3 crea audio y lo integra en los videos que produce, logrando una experiencia de sincronización audiovisual perfecta, haciendo que tus videos sean más atractivos y realistas.',

        // Función de video de referencia y personajes consistentes
        referenceVideoTitle: 'Video de Referencia y Personajes Consistentes',
        referenceVideoDescription: 'Crea videos con personajes consistentes basados en materiales de referencia, asegurando una alta consistencia en la apariencia y características de los personajes a través de diferentes escenas.',

        // Función de control de cámara
        cameraControlTitle: 'Control de Cámara',
        cameraControlDescription: 'Crea videos con efectos específicos de movimiento de cámara, soportando movimientos de lentes profesionales como empujar, tirar, panorámica e inclinación para crear efectos visuales cinematográficos.',

        // Función de creación de contenido viral
        viralContentTitle: 'Creación de Contenido Viral',
        viralContentDescription: 'Crea videos atractivos de "noticias falsas" o cortos de viajes en el tiempo para ayudarte a ganar me gusta y volverse viral fácilmente en las redes sociales.',

        // Función de comprensión avanzada de prompts
        advancedPromptTitle: 'Comprensión Avanzada de Prompts',
        advancedPromptDescription: 'Interpreta con precisión prompts complejos, comprende precisamente tus intenciones creativas y transforma descripciones de texto en escenas visuales vívidas.',

        // Función de control de estilo preciso
        preciseStyleControlTitle: 'Control de Estilo Preciso',
        preciseStyleControlDescription: 'Controla el estilo artístico basado en imágenes de referencia, logrando una personalización precisa del estilo visual para presentar perfectamente tu creatividad.',

        // Función de primer y último fotograma
        firstLastFrameTitle: 'Primer y Último Fotograma',
        firstLastFrameDescription: 'Genera videos fluidos entre dos imágenes cargadas, logrando transiciones de escena precisas y conexiones visuales suaves.',

        // Función de agregar y eliminar objetos
        addRemoveObjectsTitle: 'Agregar y Eliminar Objetos',
        addRemoveObjectsDescription: 'Agrega o elimina objetos en escenas de video, permitiendo edición flexible de escenas y expresión creativa.',

        // Función de control de movimiento flexible
        flexibleMotionControlTitle: 'Control de Movimiento Flexible',
        flexibleMotionControlDescription: 'Personaliza trayectorias de movimiento de objetos de video, controla con precisión el rendimiento de animación de cada elemento, creando efectos dinámicos únicos.',

        // Sección de cómo usar
        howToUseTitle: 'Cómo Usar',
        howToUseSubtitle: 'Tres simples pasos para comenzar',
        step1Title: 'Seleccionar Modelo',
        step1Description: 'Elige el modelo Veo 3 en herramientas de video AI',
        step2Title: 'Ingresar Contenido',
        step2Description: 'Ingresa prompts o carga imágenes de referencia',
        step3Title: 'Generar Video',
        step3Description: 'Haz clic en el botón generar, espera y descarga tu video',

        // Sección de videos de YouTube
        youtubeTitle: 'Videos de YouTube sobre el Modelo de Video AI Google Veo 3',
        youtubeVideosTitle: 'Videos de YouTube sobre el Modelo de Video AI Google Veo 3',
        youtubeVideoTitle: 'Videos de YouTube sobre el Modelo de Video AI Google Veo 3',

        // Sección de publicaciones de X
        xPostsTitle: 'Publicaciones de X sobre el Modelo de Video AI Veo 3',

        // Sección de explorar otros modelos
        exploreModelsTitle: 'Explorar Otros Modelos de Video',
        veoModelsTitle: 'Modelos Google Veo',
        veo2Title: 'Generador de Video AI Google Veo 2',
        veo31Title: 'Generador de Video AI Google Veo 3.1',
        veo3FastTitle: 'Generador de Video AI Google Veo 3 Fast',
        sora2Title: 'Generador de Video AI OpenAI Sora-2',
        klingTitle: 'Generador de Video AI Kling',

        // Sección de FAQ
        faqTitle: 'Preguntas Frecuentes',

        // Sección de CTA
        ctaTitle: '¿Listo para Comenzar a Crear?',
        ctaSubtitle: 'Experimenta Veo 3 ahora y transforma tu creatividad en videos increíbles',
        ctaDescription: 'Experimenta Veo 3 ahora y transforma tu creatividad en videos increíbles',
        ctaButton: 'Prueba Veo 3 en WeryAI',
        ctaNote: 'No se requiere tarjeta de crédito',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',

        // Relacionado con reproducción de video
        videoNotSupported: 'Su navegador no soporta reproducción de video',
        videoUnsupported: 'Su navegador no soporta reproducción de video',
        videoLoadingError: 'Error al cargar el video',
        videoLoadError: 'Error al cargar el video',
        videoReload: 'Recargar',
    },
    fr: {
        // Titre et description de la page
        pageTitle: 'Générateur de Vidéo AI Google Veo 3 - Outil de Création de Vidéo AI Révolutionnaire Gratuit | WeryAI',
        pageDescription: 'Découvrez le générateur de vidéo AI Google Veo 3 avec génération audio native, vidéo de référence, contrôle de caméra et fonctionnalités principales. Essayez-le gratuitement sur la plateforme WeryAI et créez du contenu vidéo AI professionnel.',
        pageKeywords: 'Veo 3, générateur de vidéo AI Google, création de vidéo AI, vidéo intelligence artificielle, outil de génération de vidéo, vidéo AI gratuite, WeryAI, production de vidéo',

        // Section du générateur
        generatorTitle: 'Générateur de Vidéo AI Google Veo 3',
        generatorDescription: 'WeryAI intègre désormais en profondeur le modèle Veo 3, Lancé en mai 2025 lors de Google I/O 2025, il représente une amélioration significative par rapport à son prédécesseur Veo 2. Essayez Veo 3 gratuitement sur le générateur de vidéo WeryAI!',
        
        // Onglets
        tabImageToVideo: 'Image vers Vidéo',
        tabTextToVideo: 'Texte vers Vidéo',

        // Section des fonctionnalités principales
        coreFeaturesTitle: 'Fonctionnalités Principales de Veo 3',
        coreFeaturesSubtitle: 'Explorez les fonctionnalités principales du générateur de vidéo AI Google Veo 3 et lancez-vous dans un voyage révolutionnaire de création de vidéo AI',

        // Fonction de génération audio native
        nativeAudioTitle: 'Génération Audio Native',
        nativeAudioDescription: 'Veo 3 crée de l\'audio et l\'intègre dans les vidéos qu\'il produit, réalisant une expérience de synchronisation audiovisuelle parfaite, rendant vos vidéos plus engageantes et réalistes.',

        // Fonction de vidéo de référence et personnages cohérents
        referenceVideoTitle: 'Vidéo de Référence et Personnages Cohérents',
        referenceVideoDescription: 'Créez des vidéos avec des personnages cohérents basés sur des matériaux de référence, assurant une grande cohérence de l\'apparence et des caractéristiques des personnages à travers différentes scènes.',

        // Fonction de contrôle de caméra
        cameraControlTitle: 'Contrôle de Caméra',
        cameraControlDescription: 'Créez des vidéos avec des effets de mouvement de caméra spécifiques, supportant des mouvements de lentilles professionnels comme pousser, tirer, panoramique et inclinaison pour créer des effets visuels cinématographiques.',

        // Fonction de création de contenu viral
        viralContentTitle: 'Création de Contenu Viral',
        viralContentDescription: 'Créez des vidéos engageantes de "fausses nouvelles" ou des courts métrages de voyage dans le temps pour vous aider à gagner des likes et devenir viral facilement sur les réseaux sociaux.',

        // Fonction de compréhension avancée des prompts
        advancedPromptTitle: 'Compréhension Avancée des Prompts',
        advancedPromptDescription: 'Interprétez avec précision des prompts complexes, comprenez précisément vos intentions créatives et transformez les descriptions textuelles en scènes visuelles vivantes.',

        // Fonction de contrôle de style précis
        preciseStyleControlTitle: 'Contrôle de Style Précis',
        preciseStyleControlDescription: 'Contrôlez le style artistique basé sur des images de référence, réalisant une personnalisation précise du style visuel pour présenter parfaitement votre créativité.',

        // Fonction de première et dernière image
        firstLastFrameTitle: 'Première et Dernière Image',
        firstLastFrameDescription: 'Générez des vidéos fluides entre deux images téléchargées, réalisant des transitions de scène précises et des connexions visuelles fluides.',

        // Fonction d'ajout et de suppression d'objets
        addRemoveObjectsTitle: 'Ajouter et Supprimer des Objets',
        addRemoveObjectsDescription: 'Ajoutez ou supprimez des objets dans les scènes vidéo, permettant une édition flexible des scènes et une expression créative.',

        // Fonction de contrôle de mouvement flexible
        flexibleMotionControlTitle: 'Contrôle de Mouvement Flexible',
        flexibleMotionControlDescription: 'Personnalisez les trajectoires de mouvement des objets vidéo, contrôlez avec précision les performances d\'animation de chaque élément, créant des effets dynamiques uniques.',

        // Section comment utiliser
        howToUseTitle: 'Comment Utiliser',
        howToUseSubtitle: 'Trois étapes simples pour commencer',
        step1Title: 'Sélectionner le Modèle',
        step1Description: 'Choisissez le modèle Veo 3 dans les outils vidéo AI',
        step2Title: 'Saisir le Contenu',
        step2Description: 'Entrez des prompts ou téléchargez des images de référence',
        step3Title: 'Générer la Vidéo',
        step3Description: 'Cliquez sur le bouton générer, attendez et téléchargez votre vidéo',

        // Section des vidéos YouTube
        youtubeTitle: 'Vidéos YouTube sur le Modèle de Vidéo AI Google Veo 3',
        youtubeVideosTitle: 'Vidéos YouTube sur le Modèle de Vidéo AI Google Veo 3',
        youtubeVideoTitle: 'Vidéos YouTube sur le Modèle de Vidéo AI Google Veo 3',

        // Section des publications X
        xPostsTitle: 'Publications X sur le Modèle de Vidéo AI Veo 3',

        // Section explorer d'autres modèles
        exploreModelsTitle: 'Explorer d\'Autres Modèles Vidéo',
        veoModelsTitle: 'Modèles Google Veo',
        veo2Title: 'Générateur de Vidéo AI Google Veo 2',
        veo31Title: 'Générateur de Vidéo AI Google Veo 3.1',
        veo3FastTitle: 'Générateur de Vidéo AI Google Veo 3 Fast',
        sora2Title: 'Générateur de Vidéo IA OpenAI Sora-2',
        klingTitle: 'Générateur de Vidéo IA Kling',

        // Section FAQ
        faqTitle: 'Questions Fréquemment Posées',

        // Section CTA
        ctaTitle: 'Prêt à Commencer à Créer?',
        ctaSubtitle: 'Découvrez Veo 3 maintenant et transformez votre créativité en vidéos incroyables',
        ctaDescription: 'Découvrez Veo 3 maintenant et transformez votre créativité en vidéos incroyables',
        ctaButton: 'Essayez Veo 3 sur WeryAI',
        ctaNote: 'Aucune carte de crédit requise',
        ctaDisclaimer: 'Aucune carte de crédit requise',

        // Relatif à la lecture vidéo
        videoNotSupported: 'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoUnsupported: 'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoLoadingError: 'Échec du chargement de la vidéo',
        videoLoadError: 'Échec du chargement de la vidéo',
        videoReload: 'Recharger',
    },
    de: {
        // Seitentitel und Beschreibung
        pageTitle: 'Google Veo 3 AI-Videogenerator - Kostenloses revolutionäres KI-Videoerstellungstool | WeryAI',
        pageDescription: 'Erleben Sie den Google Veo 3 AI-Videogenerator mit nativer Audiogenerierung, Referenzvideo, Kamerasteuerung und Kernfunktionen. Probieren Sie es kostenlos auf der WeryAI-Plattform aus und erstellen Sie professionelle AI-Videoinhalte.',
        pageKeywords: 'Veo 3, Google AI-Videogenerator, AI-Videoerstellung, künstliche Intelligenz Video, Videogenerierungstool, kostenloses AI-Video, WeryAI, Videoproduktion',

        // Generator-Bereich
        generatorTitle: 'Google Veo 3 AI-Videogenerator',
        generatorDescription: 'WeryAI integriert jetzt das Modell Veo 3 tiefgreifend, das hochwertige, realistische Audio-Video-Inhalte generieren kann. Es wurde im Mai 2025 bei Google I/O 2025 veröffentlicht und stellt eine erhebliche Verbesserung gegenüber seinem Vorgänger Veo 2 dar. Probieren Sie Veo 3 kostenlos auf dem WeryAI-Videogenerator aus!',
        
        // Registerkarten
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',

        // Kernfunktionen-Bereich
        coreFeaturesTitle: 'Veo 3 Kernfunktionen',
        coreFeaturesSubtitle: 'Entdecken Sie die Kernfunktionen des Google Veo 3 AI-Videogenerators und begeben Sie sich auf eine revolutionäre Reise der AI-Videoerstellung',

        // Native Audiogenerierungsfunktion
        nativeAudioTitle: 'Native Audiogenerierung',
        nativeAudioDescription: 'Veo 3 erstellt Audio und integriert es in die von ihm produzierten Videos, um eine perfekte audiovisuelle Synchronisationserfahrung zu erreichen und Ihre Videos ansprechender und realistischer zu machen.',

        // Referenzvideo und konsistente Charaktere Funktion
        referenceVideoTitle: 'Referenzvideo und Konsistente Charaktere',
        referenceVideoDescription: 'Erstellen Sie charakterkonsistente Videos basierend auf Referenzmaterialien und gewährleisten Sie eine hohe Konsistenz von Aussehen und Eigenschaften der Charaktere über verschiedene Szenen hinweg.',

        // Kamerasteuerungsfunktion
        cameraControlTitle: 'Kamerasteuerung',
        cameraControlDescription: 'Erstellen Sie Videos mit spezifischen Kamerabewegungseffekten, unterstützen Sie professionelle Objektivbewegungen wie Drücken, Ziehen, Schwenken und Neigen, um filmische visuelle Effekte zu erzeugen.',

        // Virale Inhaltserstellungsfunktion
        viralContentTitle: 'Virale Inhaltserstellung',
        viralContentDescription: 'Erstellen Sie ansprechende "Fake News"-Videos oder Zeitreise-Kurzfilme, um Ihnen zu helfen, Likes zu gewinnen und auf Social Media leicht viral zu gehen.',

        // Erweiterte Prompt-Verständnisfunktion
        advancedPromptTitle: 'Erweiterte Prompt-Verständnis',
        advancedPromptDescription: 'Interpretieren Sie komplexe Prompts präzise, verstehen Sie Ihre kreativen Absichten genau und transformieren Sie Textbeschreibungen in lebendige visuelle Szenen.',

        // Präzise Stilkontrollfunktion
        preciseStyleControlTitle: 'Präzise Stilkontrolle',
        preciseStyleControlDescription: 'Kontrollieren Sie den künstlerischen Stil basierend auf Referenzbildern, erreichen Sie eine präzise visuelle Stilanpassung, um Ihre Kreativität perfekt zu präsentieren.',

        // Erstes und letztes Bild Funktion
        firstLastFrameTitle: 'Erstes und Letztes Bild',
        firstLastFrameDescription: 'Generieren Sie nahtlose Videos zwischen zwei hochgeladenen Bildern und erreichen Sie präzise Szenenübergänge und flüssige visuelle Verbindungen.',

        // Objekte hinzufügen und entfernen Funktion
        addRemoveObjectsTitle: 'Objekte Hinzufügen und Entfernen',
        addRemoveObjectsDescription: 'Fügen Sie Objekte in Videoszenen hinzu oder entfernen Sie sie, ermöglichen Sie flexible Szenenbearbeitung und kreativen Ausdruck.',

        // Flexible Bewegungssteuerungsfunktion
        flexibleMotionControlTitle: 'Flexible Bewegungssteuerung',
        flexibleMotionControlDescription: 'Passen Sie Bewegungsverläufe von Videoobjekten an, kontrollieren Sie präzise die Animationsleistung jedes Elements und erstellen Sie einzigartige dynamische Effekte.',

        // Anwendungsbereich
        howToUseTitle: 'Anwendung',
        howToUseSubtitle: 'Drei einfache Schritte zum Loslegen',
        step1Title: 'Modell Auswählen',
        step1Description: 'Wählen Sie das Veo 3-Modell in AI-Videotools aus',
        step2Title: 'Inhalt Eingeben',
        step2Description: 'Geben Sie Prompts ein oder laden Sie Referenzbilder hoch',
        step3Title: 'Video Generieren',
        step3Description: 'Klicken Sie auf die Generieren-Schaltfläche, warten Sie und laden Sie Ihr Video herunter',

        // YouTube-Videos-Bereich
        youtubeTitle: 'YouTube-Videos zum Google Veo 3 AI-Videomodell',
        youtubeVideosTitle: 'YouTube-Videos zum Google Veo 3 AI-Videomodell',
        youtubeVideoTitle: 'YouTube-Videos zum Google Veo 3 AI-Videomodell',

        // X-Beiträge-Bereich
        xPostsTitle: 'X-Beiträge über das Veo 3 AI-Videomodell',

        // Andere Modelle erkunden Bereich
        exploreModelsTitle: 'Andere Video-Modelle Erkunden',
        veoModelsTitle: 'Google Veo-Modelle',
        veo2Title: 'Google Veo 2 AI-Videogenerator',
        veo31Title: 'Google Veo 3.1 AI-Videogenerator',
        veo3FastTitle: 'Google Veo 3 Fast AI-Videogenerator',
        sora2Title: 'OpenAI Sora-2 KI-Videogenerator',
        klingTitle: 'Kling KI-Videogenerator',

        // FAQ-Bereich
        faqTitle: 'Häufig Gestellte Fragen',

        // CTA-Bereich
        ctaTitle: 'Bereit zum Erstellen?',
        ctaSubtitle: 'Erleben Sie Veo 3 jetzt und verwandeln Sie Ihre Kreativität in erstaunliche Videos',
        ctaDescription: 'Erleben Sie Veo 3 jetzt und verwandeln Sie Ihre Kreativität in erstaunliche Videos',
        ctaButton: 'Probieren Sie Veo 3 auf WeryAI aus',
        ctaNote: 'Keine Kreditkarte erforderlich',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',

        // Videowiedergabe-bezogen
        videoNotSupported: 'Ihr Browser unterstützt keine Videowiedergabe',
        videoUnsupported: 'Ihr Browser unterstützt keine Videowiedergabe',
        videoLoadingError: 'Fehler beim Laden des Videos',
        videoLoadError: 'Fehler beim Laden des Videos',
        videoReload: 'Neu laden',
    },
    ru: {
        // Заголовок и описание страницы
        pageTitle: 'Google Veo 3 AI Генератор Видео - Бесплатный Революционный Инструмент для Создания AI Видео | WeryAI',
        pageDescription: 'Испытайте генератор видео Google Veo 3 AI с нативной генерацией аудио, референсным видео, управлением камерой и основными функциями. Попробуйте бесплатно на платформе WeryAI и создавайте профессиональный AI видеоконтент.',
        pageKeywords: 'Veo 3, генератор видео Google AI, создание AI видео, искусственный интеллект видео, инструмент генерации видео, бесплатное AI видео, WeryAI, производство видео',

        // Раздел генератора
        generatorTitle: 'Google Veo 3 AI Генератор Видео',
        generatorDescription: 'WeryAI теперь глубоко интегрировал модель Veo 3, способная генерировать высококачественный, реалистичный аудио-видео контент. Выпущенная в мае 2025 года на Google I/O 2025, она представляет собой значительное улучшение по сравнению с предшественником Veo 2. Попробуйте Veo 3 бесплатно на генераторе видео WeryAI!',
        
        // Вкладки
        tabImageToVideo: 'Изображение в Видео',
        tabTextToVideo: 'Текст в Видео',

        // Раздел основных функций
        coreFeaturesTitle: 'Основные Функции Veo 3',
        coreFeaturesSubtitle: 'Изучите основные функции генератора видео Google Veo 3 AI и отправьтесь в революционное путешествие по созданию AI видео',

        // Функция нативной генерации аудио
        nativeAudioTitle: 'Нативная Генерация Аудио',
        nativeAudioDescription: 'Veo 3 создает аудио и интегрирует его в производимые видео, достигая идеальной синхронизации аудиовизуального опыта, делая ваши видео более привлекательными и реалистичными.',

        // Функция референсного видео и последовательных персонажей
        referenceVideoTitle: 'Референсное Видео и Последовательные Персонажи',
        referenceVideoDescription: 'Создавайте видео с последовательными персонажами на основе референсных материалов, обеспечивая высокую согласованность внешнего вида и характеристик персонажей в разных сценах.',

        // Функция управления камерой
        cameraControlTitle: 'Управление Камерой',
        cameraControlDescription: 'Создавайте видео с определенными эффектами движения камеры, поддерживая профессиональные движения объектива, такие как наезд, отъезд, панорамирование и наклон для создания кинематографических визуальных эффектов.',

        // Функция создания вирусного контента
        viralContentTitle: 'Создание Вирусного Контента',
        viralContentDescription: 'Создавайте увлекательные видео "фейковых новостей" или короткометражки о путешествиях во времени, чтобы помочь вам получить лайки и легко стать вирусными в социальных сетях.',

        // Функция расширенного понимания промптов
        advancedPromptTitle: 'Расширенное Понимание Промптов',
        advancedPromptDescription: 'Точно интерпретируйте сложные промпты, точно понимайте ваши творческие намерения и трансформируйте текстовые описания в яркие визуальные сцены.',

        // Функция точного контроля стиля
        preciseStyleControlTitle: 'Точный Контроль Стиля',
        preciseStyleControlDescription: 'Управляйте художественным стилем на основе референсных изображений, достигая точной настройки визуального стиля для идеального представления вашего творчества.',

        // Функция первого и последнего кадра
        firstLastFrameTitle: 'Первый и Последний Кадр',
        firstLastFrameDescription: 'Генерируйте бесшовные видео между двумя загруженными изображениями, достигая точных переходов сцен и плавных визуальных соединений.',

        // Функция добавления и удаления объектов
        addRemoveObjectsTitle: 'Добавление и Удаление Объектов',
        addRemoveObjectsDescription: 'Добавляйте или удаляйте объекты в видеосценах, обеспечивая гибкое редактирование сцен и творческое выражение.',

        // Функция гибкого управления движением
        flexibleMotionControlTitle: 'Гибкое Управление Движением',
        flexibleMotionControlDescription: 'Настраивайте траектории движения видеообъектов, точно контролируйте анимационные характеристики каждого элемента, создавая уникальные динамические эффекты.',

        // Раздел как использовать
        howToUseTitle: 'Как Использовать',
        howToUseSubtitle: 'Три простых шага для начала',
        step1Title: 'Выберите Модель',
        step1Description: 'Выберите модель Veo 3 в инструментах AI видео',
        step2Title: 'Введите Контент',
        step2Description: 'Введите промпты или загрузите референсные изображения',
        step3Title: 'Генерируйте Видео',
        step3Description: 'Нажмите кнопку генерации, подождите и скачайте ваше видео',

        // Раздел видео YouTube
        youtubeTitle: 'Видео YouTube о Модели AI Видео Google Veo 3',
        youtubeVideosTitle: 'Видео YouTube о Модели AI Видео Google Veo 3',
        youtubeVideoTitle: 'Видео YouTube о Модели AI Видео Google Veo 3',

        // Раздел публикаций X
        xPostsTitle: 'Публикации X о Модели AI Видео Veo 3',

        // Раздел изучения других моделей
        exploreModelsTitle: 'Изучите Другие Видео Модели',
        veoModelsTitle: 'Модели Google Veo',
        veo2Title: 'Google Veo 2 AI Генератор Видео',
        veo31Title: 'Google Veo 3.1 AI Генератор Видео',
        veo3FastTitle: 'Google Veo 3 Fast AI Генератор Видео',
        sora2Title: 'OpenAI Sora-2 AI Генератор Видео',
        klingTitle: 'kling 2.5 Генератор Видео',

        // Раздел FAQ
        faqTitle: 'Часто Задаваемые Вопросы',

        // Раздел CTA
        ctaTitle: 'Готовы Начать Создавать?',
        ctaSubtitle: 'Испытайте Veo 3 прямо сейчас и превратите ваше творчество в потрясающие видео',
        ctaDescription: 'Испытайте Veo 3 прямо сейчас и превратите ваше творчество в потрясающие видео',
        ctaButton: 'Попробуйте Veo 3 на WeryAI',
        ctaNote: 'Кредитная карта не требуется',
        ctaDisclaimer: 'Кредитная карта не требуется',

        // Связанное с воспроизведением видео
        videoNotSupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoUnsupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoLoadingError: 'Ошибка загрузки видео',
        videoLoadError: 'Ошибка загрузки видео',
        videoReload: 'Перезагрузить',
    },
    pt: {
        // Título e descrição da página
        pageTitle: 'Gerador de Vídeo AI Google Veo 3 - Ferramenta Revolucionária Gratuita de Criação de Vídeo AI | WeryAI',
        pageDescription: 'Experimente o gerador de vídeo AI Google Veo 3 com geração de áudio nativa, vídeo de referência, controle de câmera e recursos principais. Experimente gratuitamente na plataforma WeryAI e crie conteúdo de vídeo AI profissional.',
        pageKeywords: 'Veo 3, gerador de vídeo AI Google, criação de vídeo AI, vídeo de inteligência artificial, ferramenta de geração de vídeo, vídeo AI grátis, WeryAI, produção de vídeo',

        // Seção do gerador
        generatorTitle: 'Gerador de Vídeo AI Google Veo 3',
        generatorDescription: 'O WeryAI agora integra profundamente o modelo Veo 3, Lançado em maio de 2025 no Google I/O 2025, representa uma melhoria significativa em relação ao seu predecessor Veo 2. Experimente o Veo 3 gratuitamente no gerador de vídeo WeryAI!',
        
        // Abas
        tabImageToVideo: 'Imagem para Vídeo',
        tabTextToVideo: 'Texto para Vídeo',

        // Seção de recursos principais
        coreFeaturesTitle: 'Recursos Principais do Veo 3',
        coreFeaturesSubtitle: 'Explore os recursos principais do gerador de vídeo AI Google Veo 3 e embarque em uma jornada revolucionária de criação de vídeo AI',

        // Recurso de geração de áudio nativa
        nativeAudioTitle: 'Geração de Áudio Nativa',
        nativeAudioDescription: 'Veo 3 cria áudio e o integra aos vídeos que produz, alcançando uma experiência perfeita de sincronização audiovisual, tornando seus vídeos mais envolventes e realistas.',

        // Recurso de vídeo de referência e personagens consistentes
        referenceVideoTitle: 'Vídeo de Referência e Personagens Consistentes',
        referenceVideoDescription: 'Crie vídeos com personagens consistentes baseados em materiais de referência, garantindo alta consistência na aparência e características dos personagens em diferentes cenas.',

        // Recurso de controle de câmera
        cameraControlTitle: 'Controle de Câmera',
        cameraControlDescription: 'Crie vídeos com efeitos específicos de movimento de câmera, suportando movimentos profissionais de lentes como empurrar, puxar, panorâmica e inclinação para criar efeitos visuais cinematográficos.',

        // Recurso de criação de conteúdo viral
        viralContentTitle: 'Criação de Conteúdo Viral',
        viralContentDescription: 'Crie vídeos envolventes de "notícias falsas" ou curtas de viagem no tempo para ajudá-lo a ganhar curtidas e facilmente se tornar viral nas redes sociais.',

        // Recurso de compreensão avançada de prompts
        advancedPromptTitle: 'Compreensão Avançada de Prompts',
        advancedPromptDescription: 'Interprete com precisão prompts complexos, compreenda precisamente suas intenções criativas e transforme descrições de texto em cenas visuais vívidas.',

        // Recurso de controle de estilo preciso
        preciseStyleControlTitle: 'Controle de Estilo Preciso',
        preciseStyleControlDescription: 'Controle o estilo artístico baseado em imagens de referência, alcançando personalização precisa do estilo visual para apresentar perfeitamente sua criatividade.',

        // Recurso de primeiro e último quadro
        firstLastFrameTitle: 'Primeiro e Último Quadro',
        firstLastFrameDescription: 'Gere vídeos perfeitos entre duas imagens carregadas, alcançando transições de cena precisas e conexões visuais suaves.',

        // Recurso de adicionar e remover objetos
        addRemoveObjectsTitle: 'Adicionar e Remover Objetos',
        addRemoveObjectsDescription: 'Adicione ou remova objetos em cenas de vídeo, permitindo edição flexível de cenas e expressão criativa.',

        // Recurso de controle de movimento flexível
        flexibleMotionControlTitle: 'Controle de Movimento Flexível',
        flexibleMotionControlDescription: 'Personalize trajetórias de movimento de objetos de vídeo, controle com precisão o desempenho de animação de cada elemento, criando efeitos dinâmicos únicos.',

        // Seção de como usar
        howToUseTitle: 'Como Usar',
        howToUseSubtitle: 'Três passos simples para começar',
        step1Title: 'Selecionar Modelo',
        step1Description: 'Escolha o modelo Veo 3 nas ferramentas de vídeo AI',
        step2Title: 'Inserir Conteúdo',
        step2Description: 'Digite prompts ou carregue imagens de referência',
        step3Title: 'Gerar Vídeo',
        step3Description: 'Clique no botão gerar, aguarde e baixe seu vídeo',

        // Seção de vídeos do YouTube
        youtubeTitle: 'Vídeos do YouTube sobre o Modelo de Vídeo AI Google Veo 3',
        youtubeVideosTitle: 'Vídeos do YouTube sobre o Modelo de Vídeo AI Google Veo 3',
        youtubeVideoTitle: 'Vídeos do YouTube sobre o Modelo de Vídeo AI Google Veo 3',

        // Seção de publicações X
        xPostsTitle: 'Publicações X sobre o Modelo de Vídeo AI Veo 3',

        // Seção de explorar outros modelos
        exploreModelsTitle: 'Explorar Outros Modelos de Vídeo',
        veoModelsTitle: 'Modelos Google Veo',
        veo2Title: 'Gerador de Vídeo AI Google Veo 2',
        veo31Title: 'Gerador de Vídeo AI Google Veo 3.1',
        veo3FastTitle: 'Gerador de Vídeo AI Google Veo 3 Fast',
        sora2Title: 'Gerador de Vídeo IA OpenAI Sora-2',
        klingTitle: 'Gerador de Vídeo IA Kling',

        // Seção de FAQ
        faqTitle: 'Perguntas Frequentes',

        // Seção CTA
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaSubtitle: 'Experimente o Veo 3 agora e transforme sua criatividade em vídeos incríveis',
        ctaDescription: 'Experimente o Veo 3 agora e transforme sua criatividade em vídeos incríveis',
        ctaButton: 'Experimente o Veo 3 no WeryAI',
        ctaNote: 'Não é necessário cartão de crédito',
        ctaDisclaimer: 'Não é necessário cartão de crédito',

        // Relacionado à reprodução de vídeo
        videoNotSupported: 'Seu navegador não suporta reprodução de vídeo',
        videoUnsupported: 'Seu navegador não suporta reprodução de vídeo',
        videoLoadingError: 'Falha ao carregar o vídeo',
        videoLoadError: 'Falha ao carregar o vídeo',
        videoReload: 'Recarregar',
    },
    it: {
        // Titolo e descrizione della pagina
        pageTitle: 'Generatore di Video AI Google Veo 3 - Strumento Rivoluzionario Gratuito per la Creazione di Video AI | WeryAI',
        pageDescription: 'Sperimenta il generatore di video AI Google Veo 3 con generazione audio nativa, video di riferimento, controllo della fotocamera e funzionalità principali. Provalo gratuitamente sulla piattaforma WeryAI e crea contenuti video AI professionali.',
        pageKeywords: 'Veo 3, generatore di video AI Google, creazione di video AI, video intelligenza artificiale, strumento di generazione video, video AI gratuito, WeryAI, produzione video',

        // Sezione del generatore
        generatorTitle: 'Generatore di Video AI Google Veo 3',
        generatorDescription: 'WeryAI integra ora in profondità il modello Veo 3, Rilasciato a maggio 2025 al Google I/O 2025, rappresenta un miglioramento significativo rispetto al suo predecessore Veo 2. Prova Veo 3 gratuitamente sul generatore di video WeryAI!',
        
        // Schede
        tabImageToVideo: 'Immagine a Video',
        tabTextToVideo: 'Testo a Video',

        // Sezione delle caratteristiche principali
        coreFeaturesTitle: 'Caratteristiche Principali di Veo 3',
        coreFeaturesSubtitle: 'Esplora le caratteristiche principali del generatore di video AI Google Veo 3 e intraprendi un viaggio rivoluzionario nella creazione di video AI',

        // Funzione di generazione audio nativa
        nativeAudioTitle: 'Generazione Audio Nativa',
        nativeAudioDescription: 'Veo 3 crea audio e lo integra nei video che produce, ottenendo un\'esperienza perfetta di sincronizzazione audiovisiva, rendendo i tuoi video più coinvolgenti e realistici.',

        // Funzione di video di riferimento e personaggi coerenti
        referenceVideoTitle: 'Video di Riferimento e Personaggi Coerenti',
        referenceVideoDescription: 'Crea video con personaggi coerenti basati su materiali di riferimento, garantendo un\'alta coerenza dell\'aspetto e delle caratteristiche dei personaggi attraverso scene diverse.',

        // Funzione di controllo della fotocamera
        cameraControlTitle: 'Controllo della Fotocamera',
        cameraControlDescription: 'Crea video con specifici effetti di movimento della fotocamera, supportando movimenti professionali dell\'obiettivo come spingere, tirare, panoramica e inclinazione per creare effetti visivi cinematografici.',

        // Funzione di creazione di contenuti virali
        viralContentTitle: 'Creazione di Contenuti Virali',
        viralContentDescription: 'Crea coinvolgenti video di "notizie false" o corti di viaggio nel tempo per aiutarti a ottenere mi piace e diventare facilmente virale sui social media.',

        // Funzione di comprensione avanzata dei prompt
        advancedPromptTitle: 'Comprensione Avanzata dei Prompt',
        advancedPromptDescription: 'Interpreta con precisione prompt complessi, comprendi precisamente le tue intenzioni creative e trasforma le descrizioni testuali in scene visive vivide.',

        // Funzione di controllo dello stile preciso
        preciseStyleControlTitle: 'Controllo dello Stile Preciso',
        preciseStyleControlDescription: 'Controlla lo stile artistico basato su immagini di riferimento, ottenendo una personalizzazione precisa dello stile visivo per presentare perfettamente la tua creatività.',

        // Funzione del primo e ultimo fotogramma
        firstLastFrameTitle: 'Primo e Ultimo Fotogramma',
        firstLastFrameDescription: 'Genera video fluidi tra due immagini caricate, ottenendo transizioni di scena precise e connessioni visive fluide.',

        // Funzione di aggiunta e rimozione di oggetti
        addRemoveObjectsTitle: 'Aggiungere e Rimuovere Oggetti',
        addRemoveObjectsDescription: 'Aggiungi o rimuovi oggetti nelle scene video, consentendo un\'edizione flessibile delle scene e un\'espressione creativa.',

        // Funzione di controllo del movimento flessibile
        flexibleMotionControlTitle: 'Controllo del Movimento Flessibile',
        flexibleMotionControlDescription: 'Personalizza le traiettorie di movimento degli oggetti video, controlla con precisione le prestazioni di animazione di ogni elemento, creando effetti dinamici unici.',

        // Sezione come usare
        howToUseTitle: 'Come Usare',
        howToUseSubtitle: 'Tre semplici passaggi per iniziare',
        step1Title: 'Seleziona Modello',
        step1Description: 'Scegli il modello Veo 3 negli strumenti video AI',
        step2Title: 'Inserisci Contenuto',
        step2Description: 'Inserisci prompt o carica immagini di riferimento',
        step3Title: 'Genera Video',
        step3Description: 'Clicca sul pulsante genera, attendi e scarica il tuo video',

        // Sezione video YouTube
        youtubeTitle: 'Video YouTube sul Modello di Video AI Google Veo 3',
        youtubeVideosTitle: 'Video YouTube sul Modello di Video AI Google Veo 3',
        youtubeVideoTitle: 'Video YouTube sul Modello di Video AI Google Veo 3',

        // Sezione post X
        xPostsTitle: 'Post X sul Modello di Video AI Veo 3',

        // Sezione esplorare altri modelli
        exploreModelsTitle: 'Esplora Altri Modelli Video',
        veoModelsTitle: 'Modelli Google Veo',
        veo2Title: 'Generatore di Video AI Google Veo 2',
        veo31Title: 'Generatore di Video AI Google Veo 3.1',
        veo3FastTitle: 'Generatore di Video AI Google Veo 3 Fast',
        sora2Title: 'Generatore di Video IA OpenAI Sora-2',
        klingTitle: 'Generatore di Video IA Kling',

        // Sezione FAQ
        faqTitle: 'Domande Frequenti',

        // Sezione CTA
        ctaTitle: 'Pronto per Iniziare a Creare?',
        ctaSubtitle: 'Sperimenta Veo 3 ora e trasforma la tua creatività in video straordinari',
        ctaDescription: 'Sperimenta Veo 3 ora e trasforma la tua creatività in video straordinari',
        ctaButton: 'Prova Veo 3 su WeryAI',
        ctaNote: 'Nessuna carta di credito richiesta',
        ctaDisclaimer: 'Nessuna carta di credito richiesta',

        // Relativo alla riproduzione video
        videoNotSupported: 'Il tuo browser non supporta la riproduzione video',
        videoUnsupported: 'Il tuo browser non supporta la riproduzione video',
        videoLoadingError: 'Errore nel caricamento del video',
        videoLoadError: 'Errore nel caricamento del video',
        videoReload: 'Ricarica',
    },
    ar: {
        // عنوان ووصف الصفحة
        pageTitle: 'مولد الفيديو بالذكاء الاصطناعي Google Veo 3 - أداة ثورية مجانية لإنشاء الفيديو بالذكاء الاصطناعي | WeryAI',
        pageDescription: 'جرب مولد الفيديو بالذكاء الاصطناعي Google Veo 3 مع توليد الصوت الأصلي، فيديو مرجعي، التحكم في الكاميرا والميزات الأساسية. جربه مجانًا على منصة WeryAI وأنشئ محتوى فيديو احترافي بالذكاء الاصطناعي.',
        pageKeywords: 'Veo 3, مولد فيديو Google AI, إنشاء فيديو AI, فيديو الذكاء الاصطناعي, أداة توليد الفيديو, فيديو AI مجاني, WeryAI, إنتاج الفيديو',

        // قسم المولد
        generatorTitle: 'مولد الفيديو بالذكاء الاصطناعي Google Veo 3',
        generatorDescription: 'يقوم WeryAI الآن بدمج نموذج Veo 3 بعمق، تم إطلاقه في مايو 2025 في مؤتمر Google I/O 2025، ويمثل تحسينًا كبيرًا مقارنة بسابقه Veo 2. جرب Veo 3 مجانًا على مولد الفيديو WeryAI!',
        
        // علامات التبويب
        tabImageToVideo: 'الصورة إلى الفيديو',
        tabTextToVideo: 'النص إلى الفيديو',

        // قسم الميزات الأساسية
        coreFeaturesTitle: 'الميزات الأساسية لـ Veo 3',
        coreFeaturesSubtitle: 'استكشف الميزات الأساسية لمولد الفيديو بالذكاء الاصطناعي Google Veo 3 وابدأ رحلة ثورية في إنشاء الفيديو بالذكاء الاصطناعي',

        // ميزة توليد الصوت الأصلي
        nativeAudioTitle: 'توليد الصوت الأصلي',
        nativeAudioDescription: 'يقوم Veo 3 بإنشاء الصوت ودمجه في مقاطع الفيديو التي ينتجها، محققًا تجربة مثالية لمزامنة الصوت والصورة، مما يجعل مقاطع الفيديو الخاصة بك أكثر جاذبية وواقعية.',

        // ميزة الفيديو المرجعي والشخصيات المتسقة
        referenceVideoTitle: 'الفيديو المرجعي والشخصيات المتسقة',
        referenceVideoDescription: 'أنشئ مقاطع فيديو بشخصيات متسقة بناءً على المواد المرجعية، مما يضمن اتساقًا عاليًا في مظهر الشخصيات وخصائصها عبر المشاهد المختلفة.',

        // ميزة التحكم في الكاميرا
        cameraControlTitle: 'التحكم في الكاميرا',
        cameraControlDescription: 'أنشئ مقاطع فيديو بتأثيرات حركة كاميرا محددة، تدعم حركات العدسة الاحترافية مثل الدفع والسحب والتحريك والإمالة لإنشاء تأثيرات بصرية سينمائية.',

        // ميزة إنشاء المحتوى الفيروسي
        viralContentTitle: 'إنشاء المحتوى الفيروسي',
        viralContentDescription: 'أنشئ مقاطع فيديو جذابة لـ "الأخبار المزيفة" أو مقاطع قصيرة للسفر عبر الزمن لمساعدتك في كسب الإعجابات والانتشار بسهولة على وسائل التواصل الاجتماعي.',

        // ميزة الفهم المتقدم للمطالبات
        advancedPromptTitle: 'الفهم المتقدم للمطالبات',
        advancedPromptDescription: 'فسر المطالبات المعقدة بدقة، افهم نواياك الإبداعية بدقة، وحوّل الأوصاف النصية إلى مشاهد بصرية حية.',

        // ميزة التحكم الدقيق في الأسلوب
        preciseStyleControlTitle: 'التحكم الدقيق في الأسلوب',
        preciseStyleControlDescription: 'تحكم في الأسلوب الفني بناءً على الصور المرجعية، محققًا تخصيصًا دقيقًا للأسلوب البصري لتقديم إبداعك بشكل مثالي.',

        // ميزة الإطار الأول والأخير
        firstLastFrameTitle: 'الإطار الأول والأخير',
        firstLastFrameDescription: 'أنشئ مقاطع فيديو سلسة بين صورتين تم تحميلهما، محققًا انتقالات مشهدية دقيقة واتصالات بصرية سلسة.',

        // ميزة إضافة وإزالة الكائنات
        addRemoveObjectsTitle: 'إضافة وإزالة الكائنات',
        addRemoveObjectsDescription: 'أضف أو أزل الكائنات في مشاهد الفيديو، مما يتيح تحرير المشاهد بمرونة والتعبير الإبداعي.',

        // ميزة التحكم المرن في الحركة
        flexibleMotionControlTitle: 'التحكم المرن في الحركة',
        flexibleMotionControlDescription: 'خصص مسارات حركة كائنات الفيديو، تحكم بدقة في أداء الرسوم المتحركة لكل عنصر، مما يخلق تأثيرات ديناميكية فريدة.',

        // قسم كيفية الاستخدام
        howToUseTitle: 'كيفية الاستخدام',
        howToUseSubtitle: 'ثلاث خطوات بسيطة للبدء',
        step1Title: 'اختر النموذج',
        step1Description: 'اختر نموذج Veo 3 في أدوات الفيديو بالذكاء الاصطناعي',
        step2Title: 'أدخل المحتوى',
        step2Description: 'أدخل المطالبات أو قم بتحميل الصور المرجعية',
        step3Title: 'إنشاء الفيديو',
        step3Description: 'انقر على زر الإنشاء، انتظر وقم بتنزيل الفيديو الخاص بك',

        // قسم مقاطع فيديو YouTube
        youtubeTitle: 'مقاطع فيديو YouTube حول نموذج الفيديو بالذكاء الاصطناعي Google Veo 3',
        youtubeVideosTitle: 'مقاطع فيديو YouTube حول نموذج الفيديو بالذكاء الاصطناعي Google Veo 3',
        youtubeVideoTitle: 'مقاطع فيديو YouTube حول نموذج الفيديو بالذكاء الاصطناعي Google Veo 3',

        // قسم منشورات X
        xPostsTitle: 'منشورات X حول نموذج الفيديو بالذكاء الاصطناعي Veo 3',

        // قسم استكشاف النماذج الأخرى
        exploreModelsTitle: 'استكشف نماذج الفيديو الأخرى',
        veoModelsTitle: 'نماذج Google Veo',
        veo2Title: 'مولد الفيديو بالذكاء الاصطناعي Google Veo 2',
        veo31Title: 'مولد الفيديو بالذكاء الاصطناعي Google Veo 3.1',
        veo3FastTitle: 'مولد الفيديو بالذكاء الاصطناعي Google Veo 3 Fast',
        sora2Title: 'مولد فيديو OpenAI Sora-2 بالذكاء الاصطناعي',
        klingTitle: 'مولد فيديو Kling بالذكاء الاصطناعي',

        // قسم الأسئلة الشائعة
        faqTitle: 'الأسئلة الشائعة',

        // قسم الدعوة لاتخاذ إجراء
        ctaTitle: 'هل أنت مستعد للبدء في الإنشاء؟',
        ctaSubtitle: 'جرب Veo 3 الآن وحوّل إبداعك إلى مقاطع فيديو مذهلة',
        ctaDescription: 'جرب Veo 3 الآن وحوّل إبداعك إلى مقاطع فيديو مذهلة',
        ctaButton: 'جرب Veo 3 على WeryAI',
        ctaNote: 'لا حاجة لبطاقة ائتمان',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',

        // متعلق بتشغيل الفيديو
        videoNotSupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoUnsupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoLoadingError: 'فشل تحميل الفيديو',
        videoLoadError: 'فشل تحميل الفيديو',
        videoReload: 'إعادة التحميل',
        },
    th: {
        // Page title and description
        pageTitle: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3 - เครื่องมือปฏิวัติใหม่ ฟรี',
        pageDescription: 'สัมผัส Google Veo 3 พร้อมการสร้างเสียงเนทีฟ วิดีโออ้างอิง การควบคุมกล้อง และฟีเจอร์หลัก ลองฟรีบน WeryAI และสร้างคอนเทนต์วิดีโอ AI ระดับมืออาชีพ',
        pageKeywords: 'Veo 3, เครื่องมือสร้างวิดีโอ AI ของ Google, การสร้างวิดีโอ AI, วิดีโอปัญญาประดิษฐ์, เครื่องมือสร้างวิดีโอ, วิดีโอ AI ฟรี, WeryAI, การผลิตวิดีโอ',

        // Generator section
        generatorTitle: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3',
        generatorDescription: 'ขณะนี้ WeryAI ได้ผสานรวมโมเดล Veo 3 อย่างลึกซึ้งแล้ว ขณะนี้ WeryAI ได้ผสานรวมโมเดล Veo 3 อย่างลึกซึ้งแล้ว ',
        
        // Tabs
        tabImageToVideo: 'ภาพเป็นวิดีโอ',
        tabTextToVideo: 'ข้อความเป็นวิดีโอ',

        // Core features section
        coreFeaturesTitle: 'ฟีเจอร์หลักของ Veo 3',
        coreFeaturesSubtitle: 'สำรวจฟีเจอร์หลักของเครื่องมือสร้างวิดีโอ AI Google Veo 3 และเริ่มต้นการสร้างวิดีโอ AI แบบปฏิวัติ',

        // Native audio generation feature
        nativeAudioTitle: 'การสร้างเสียงเนทีฟ',
        nativeAudioDescription: 'Veo 3 สร้างเสียงและผสานเข้ากับวิดีโอที่ผลิตได้ ทำให้ซิงก์ภาพและเสียงอย่างสมบูรณ์ วิดีโอจึงดึงดูดและสมจริงยิ่งขึ้น',

        // Reference video and consistent characters feature
        referenceVideoTitle: 'วิดีโออ้างอิงและตัวละครคงที่',
        referenceVideoDescription: 'สร้างวิดีโอที่ตัวละครคงเอกลักษณ์จากวัสดุอ้างอิง ทำให้รูปลักษณ์และลักษณะตัวละครสอดคล้องกันในทุกฉาก',

        // Camera control feature
        cameraControlTitle: 'ควบคุมกล้อง',
        cameraControlDescription: 'สร้างวิดีโอด้วยการเคลื่อนกล้องเฉพาะทาง รองรับการเคลื่อนเลนส์แบบ push, pull, pan และ tilt เพื่อเอฟเฟกต์ภาพยนตร์',

        // Viral content creation feature
        viralContentTitle: 'สร้างคอนเทนต์ไวรัล',
        viralContentDescription: 'สร้างวิดีโอ "ข่าวปลอม" หรือคลิปย้อนเวลา เพื่อช่วยให้ได้ไลก์และไวรัลง่ายบนโซเชียล',

        // Advanced prompt understanding feature
        advancedPromptTitle: 'เข้าใจพรอมต์ขั้นสูง',
        advancedPromptDescription: 'ตีความพรอมต์ซับซ้อนได้แม่นยำ เข้าใจเจตนาสร้างสรรค์ และแปลงข้อความเป็นฉากภาพที่มีชีวิตชีวา',

        // Precise style control feature
        preciseStyleControlTitle: 'ควบคุมสไตล์อย่างแม่นยำ',
        preciseStyleControlDescription: 'ควบคุมสไตล์ศิลปะจากภาพอ้างอิง ปรับแต่งสไตล์ภาพอย่างละเอียดเพื่อนำเสนอความคิดสร้างสรรค์อย่างสมบูรณ์',

        // First and last frame feature
        firstLastFrameTitle: 'เฟรมแรกและเฟรมสุดท้าย',
        firstLastFrameDescription: 'สร้างวิดีโอเชื่อมต่ออย่างลื่นไหลระหว่างสองภาพที่อัปโหลด เพื่อการเปลี่ยนฉากที่แม่นยำและต่อเนื่อง',

        // Add and remove objects feature
        addRemoveObjectsTitle: 'เพิ่มและลบวัตถุ',
        addRemoveObjectsDescription: 'เพิ่มหรือลบวัตถุในฉากวิดีโอ ช่วยให้แก้ไขฉากได้ยืดหยุ่นและสร้างสรรค์',

        // Flexible motion control feature
        flexibleMotionControlTitle: 'ควบคุมการเคลื่อนไหวแบบยืดหยุ่น',
        flexibleMotionControlDescription: 'ปรับเส้นทางการเคลื่อนไหวของวัตถุในวิดีโอ ควบคุมการเคลื่อนไหวของแต่ละองค์ประกอบอย่างแม่นยำ สร้างเอฟเฟกต์ไดนามิกเฉพาะตัว',

        // How to use section
        howToUseTitle: 'วิธีใช้งาน',
        howToUseSubtitle: '3 ขั้นตอนง่าย ๆ เริ่มต้นได้ทันที',
        step1Title: 'เลือกโมเดล',
        step1Description: 'เลือกโมเดล Veo 3 ในเครื่องมือวิดีโอ AI',
        step2Title: 'ป้อนเนื้อหา',
        step2Description: 'พิมพ์พรอมต์หรืออัปโหลดภาพอ้างอิง',
        step3Title: 'สร้างวิดีโอ',
        step3Description: 'กดปุ่มสร้าง รอ และดาวน์โหลดวิดีโอของคุณ',

        // YouTube videos section
        youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดลวิดีโอ AI Google Veo 3',
        youtubeVideosTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดลวิดีโอ AI Google Veo 3',
        youtubeVideoTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดลวิดีโอ AI Google Veo 3',

        // X Posts section
        xPostsTitle: 'โพสต์บน X เกี่ยวกับโมเดลวิดีโอ AI Veo 3',

        // Explore other models section
        exploreModelsTitle: 'สำรวจโมเดลวิดีโออื่น ๆ',
        veoModelsTitle: 'โมเดล Google Veo',
        veo2Title: 'เครื่องมือสร้างวิดีโอ AI Google Veo 2',
        veo31Title: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3.1',
        veo3FastTitle: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3 Fast',
        sora2Title: 'เครื่องมือสร้างวิดีโอ AI OpenAI Sora-2',
        klingTitle: 'เครื่องมือสร้างวิดีโอ Kling 2.5',

        // FAQ section
        faqTitle: 'คำถามที่พบบ่อย',

        // CTA section
        ctaTitle: 'พร้อมเริ่มสร้างแล้วหรือยัง?',
        ctaSubtitle: 'ลอง Veo 3 ตอนนี้และเปลี่ยนความคิดสร้างสรรค์เป็นวิดีโอสุดว้าว',
        ctaDescription: 'ลอง Veo 3 ตอนนี้และเปลี่ยนความคิดสร้างสรรค์เป็นวิดีโอสุดว้าว',
        ctaButton: 'ลอง Veo 3 บน WeryAI',
        ctaNote: 'ไม่ต้องใช้บัตรเครดิต',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต',

        // Video playback related
        videoNotSupported: 'เบราว์เซอร์ของคุณไม่รองรับการเล่นวิดีโอ',
        videoUnsupported: 'เบราว์เซอร์ของคุณไม่รองรับการเล่นวิดีโอ',
        videoLoadingError: 'โหลดวิดีโอล้มเหลว',
        videoLoadError: 'โหลดวิดีโอล้มเหลว',
        videoReload: 'โหลดใหม่',
        },
    da: {
        // Page title and description
        pageTitle: 'Google Veo 3 AI-videogenerator - gratis revolutionerende AI-videoværktøj',
        pageDescription: 'Oplev Google Veo 3 AI-videogenerator med indbygget lydgenerering, referencevideo, kamerakontrol og kernefunktioner. Prøv gratis på WeryAI og skab professionelle AI-videoer.',
        pageKeywords: 'Veo 3, Google AI-videogenerator, AI-videoskabelse, kunstig intelligens video, videogenereringsværktøj, gratis AI-video, WeryAI, videoproduktion',

        // Generator section
        generatorTitle: 'Google Veo 3 AI-videogenerator',
        generatorDescription: 'WeryAI har nu integreret modellen Veo 3 i dybden, der kan generere realistisk audio-video i høj kvalitet. Den blev lanceret i maj 2025 på Google I/O 2025 og er en markant forbedring i forhold til Veo 2. Prøv Veo 3 gratis på WeryAI-videogeneratoren!',
        
        // Tabs
        tabImageToVideo: 'Billede til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Veo 3 kernefunktioner',
        coreFeaturesSubtitle: 'Udforsk kernefunktionerne i Google Veo 3 AI-videogenerator og start en revolutionerende AI-videoskabelsesrejse',

        // Native audio generation feature
        nativeAudioTitle: 'Indbygget lydgenerering',
        nativeAudioDescription: 'Veo 3 genererer lyd og integrerer den i videoerne, så du får perfekt lyd-billedsynk, der gør dine videoer mere engagerende og realistiske.',

        // Reference video and consistent characters feature
        referenceVideoTitle: 'Referencevideo og konsistente karakterer',
        referenceVideoDescription: 'Skab videoer med konsistente karakterer baseret på referencemateriale og sikr høj konsistens i udseende og egenskaber på tværs af scener.',

        // Camera control feature
        cameraControlTitle: 'Kamerakontrol',
        cameraControlDescription: 'Skab videoer med specifikke kamerabevægelser og understøt professionelle linsebevægelser som push, pull, pan og tilt for filmiske effekter.',

        // Viral content creation feature
        viralContentTitle: 'Viral indholdsskabelse',
        viralContentDescription: 'Skab engagerende "fake news"-videoer eller tidsrejseklip, der hjælper dig med likes og gør det let at gå viralt på sociale medier.',

        // Advanced prompt understanding feature
        advancedPromptTitle: 'Avanceret promptforståelse',
        advancedPromptDescription: 'Fortolk komplekse prompts præcist, forstå dine kreative intentioner og omsæt tekst til levende visuelle scener.',

        // Precise style control feature
        preciseStyleControlTitle: 'Præcis stilkontrol',
        preciseStyleControlDescription: 'Styr kunstnerisk stil ud fra referencebilleder og få præcis visuel tilpasning, der præsenterer din kreativitet perfekt.',

        // First and last frame feature
        firstLastFrameTitle: 'Første og sidste frame',
        firstLastFrameDescription: 'Generér sømløse videoer mellem to uploadede billeder med præcise sceneskift og glatte overgange.',

        // Add and remove objects feature
        addRemoveObjectsTitle: 'Tilføj og fjern objekter',
        addRemoveObjectsDescription: 'Tilføj eller fjern objekter i videoscener, så du får fleksibel redigering og kreativt udtryk.',

        // Flexible motion control feature
        flexibleMotionControlTitle: 'Fleksibel bevægelseskontrol',
        flexibleMotionControlDescription: 'Tilpas bevægelsesbaner for videoobjekter og styr animationen præcist for unikke dynamiske effekter.',

        // How to use section
        howToUseTitle: 'Sådan bruges det',
        howToUseSubtitle: 'Tre enkle trin til at komme i gang',
        step1Title: 'Vælg model',
        step1Description: 'Vælg Veo 3-modellen i AI-videoværktøjer',
        step2Title: 'Indtast indhold',
        step2Description: 'Indtast prompts eller upload referencebilleder',
        step3Title: 'Generér video',
        step3Description: 'Klik på generér, vent og download din video',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer om Google Veo 3 AI-videomodel',
        youtubeVideosTitle: 'YouTube-videoer om Google Veo 3 AI-videomodel',
        youtubeVideoTitle: 'YouTube-videoer om Google Veo 3 AI-videomodel',

        // X Posts section
        xPostsTitle: 'X-opslag om Veo 3 AI-videomodellen',

        // Explore other models section
        exploreModelsTitle: 'Udforsk andre videomodeller',
        veoModelsTitle: 'Google Veo-modeller',
        veo2Title: 'Google Veo 2 AI-videogenerator',
        veo31Title: 'Google Veo 3.1 AI-videogenerator',
        veo3FastTitle: 'Google Veo 3 Fast AI-videogenerator',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        klingTitle: 'Kling 2.5 videogenerator',

        // FAQ section
        faqTitle: 'Ofte stillede spørgsmål',

        // CTA section
        ctaTitle: 'Klar til at skabe?',
        ctaSubtitle: 'Prøv Veo 3 nu og forvandl din kreativitet til fantastiske videoer',
        ctaDescription: 'Prøv Veo 3 nu og forvandl din kreativitet til fantastiske videoer',
        ctaButton: 'Prøv Veo 3 på WeryAI',
        ctaNote: 'Intet kreditkort kræves',
        ctaDisclaimer: 'Intet kreditkort kræves',

        // Video playback related
        videoNotSupported: 'Din browser understøtter ikke videoafspilning',
        videoUnsupported: 'Din browser understøtter ikke videoafspilning',
        videoLoadingError: 'Videoindlæsning mislykkedes',
        videoLoadError: 'Videoindlæsning mislykkedes',
        videoReload: 'Genindlæs',
        },
    no: {
        // Page title and description
        pageTitle: 'Google Veo 3 AI-videogenerator - gratis revolusjonerende AI-verktøy',
        pageDescription: 'Opplev Google Veo 3 AI-videogenerator med innebygd lydgenerering, referansevideo, kamerakontroll og kjernefunksjoner. Prøv gratis på WeryAI og lag profesjonelt AI-videoinnhold.',
        pageKeywords: 'Veo 3, Google AI-videogenerator, AI-videoskaping, kunstig intelligens video, videogenereringsverktøy, gratis AI-video, WeryAI, videoproduksjon',

        // Generator section
        generatorTitle: 'Google Veo 3 AI-videogenerator',
        generatorDescription: 'WeryAI har nå integrert modellen Veo 3 i dybden, Den ble lansert i mai 2025 på Google I/O 2025 og er en stor forbedring fra Veo 2. Prøv Veo 3 gratis på WeryAI-videogeneratoren!',
        
        // Tabs
        tabImageToVideo: 'Bilde til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Veo 3 kjernefunksjoner',
        coreFeaturesSubtitle: 'Utforsk kjernefunksjonene i Google Veo 3 AI-videogenerator og start en revolusjonerende AI-videoreise',

        // Native audio generation feature
        nativeAudioTitle: 'Innebygd lydgenerering',
        nativeAudioDescription: 'Veo 3 lager lyd og integrerer den i videoene som produseres, for perfekt lyd-bildesynk som gjør videoene mer engasjerende og realistiske.',

        // Reference video and consistent characters feature
        referenceVideoTitle: 'Referansevideo og konsistente karakterer',
        referenceVideoDescription: 'Lag videoer med konsistente karakterer basert på referansemateriale, slik at utseende og egenskaper holder seg stabile på tvers av scener.',

        // Camera control feature
        cameraControlTitle: 'Kamerakontroll',
        cameraControlDescription: 'Lag videoer med spesifikke kamerabevegelser og profesjonelle linsebevegelser som push, pull, pan og tilt for filmatiske effekter.',

        // Viral content creation feature
        viralContentTitle: 'Skap viralt innhold',
        viralContentDescription: 'Lag engasjerende "fake news"-videoer eller tidsreise-klipp for å få likes og gå viralt på sosiale medier.',

        // Advanced prompt understanding feature
        advancedPromptTitle: 'Avansert promptforståelse',
        advancedPromptDescription: 'Tolker komplekse prompts nøyaktig, forstår dine kreative intensjoner og gjør tekstbeskrivelser om til levende visuelle scener.',

        // Precise style control feature
        preciseStyleControlTitle: 'Presis stilkontroll',
        preciseStyleControlDescription: 'Styr den kunstneriske stilen med referansebilder og oppnå presis visuell tilpasning som viser kreativiteten din perfekt.',

        // First and last frame feature
        firstLastFrameTitle: 'Første og siste bilde',
        firstLastFrameDescription: 'Generer sømløse videoer mellom to opplastede bilder med presise sceneskift og glatte overganger.',

        // Add and remove objects feature
        addRemoveObjectsTitle: 'Legg til og fjern objekter',
        addRemoveObjectsDescription: 'Legg til eller fjern objekter i videoscener for fleksibel redigering og kreativt uttrykk.',

        // Flexible motion control feature
        flexibleMotionControlTitle: 'Fleksibel bevegelseskontroll',
        flexibleMotionControlDescription: 'Tilpass bevegelsesbaner for videoobjekter og styr animasjonen presist for unike dynamiske effekter.',

        // How to use section
        howToUseTitle: 'Slik bruker du',
        howToUseSubtitle: 'Tre enkle trinn for å komme i gang',
        step1Title: 'Velg modell',
        step1Description: 'Velg Veo 3-modellen i AI-videoverktøy',
        step2Title: 'Skriv inn innhold',
        step2Description: 'Skriv inn prompts eller last opp referansebilder',
        step3Title: 'Generer video',
        step3Description: 'Klikk generer, vent og last ned videoen din',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer om Google Veo 3 AI-videomodell',
        youtubeVideosTitle: 'YouTube-videoer om Google Veo 3 AI-videomodell',
        youtubeVideoTitle: 'YouTube-videoer om Google Veo 3 AI-videomodell',

        // X Posts section
        xPostsTitle: 'X-innlegg om Veo 3 AI-videomodellen',

        // Explore other models section
        exploreModelsTitle: 'Utforsk andre videomodeller',
        veoModelsTitle: 'Google Veo-modeller',
        veo2Title: 'Google Veo 2 AI-videogenerator',
        veo31Title: 'Google Veo 3.1 AI-videogenerator',
        veo3FastTitle: 'Google Veo 3 Fast AI-videogenerator',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        klingTitle: 'Kling 2.5 videogenerator',

        // FAQ section
        faqTitle: 'Ofte stilte spørsmål',

        // CTA section
        ctaTitle: 'Klar til å skape?',
        ctaSubtitle: 'Prøv Veo 3 nå og gjør kreativiteten din om til fantastiske videoer',
        ctaDescription: 'Prøv Veo 3 nå og gjør kreativiteten din om til fantastiske videoer',
        ctaButton: 'Prøv Veo 3 på WeryAI',
        ctaNote: 'Ingen kredittkort nødvendig',
        ctaDisclaimer: 'Ingen kredittkort nødvendig',

        // Video playback related
        videoNotSupported: 'Nettleseren din støtter ikke videoavspilling',
        videoUnsupported: 'Nettleseren din støtter ikke videoavspilling',
        videoLoadingError: 'Videolasting mislyktes',
        videoLoadError: 'Videolasting mislyktes',
        videoReload: 'Last inn på nytt',
        },
    nl: {
        // Page title and description
        pageTitle: 'Google Veo 3 AI-videogenerator - gratis revolutionair AI-videotool',
        pageDescription: 'Ervaar Google Veo 3 met native audiogeneratie, referentievideo, cameracontrole en kernfuncties. Probeer gratis op WeryAI en maak professioneel AI-videocontent.',
        pageKeywords: 'Veo 3, Google AI-videogenerator, AI-videocreatie, kunstmatige intelligentie video, videogeneratie tool, gratis AI-video, WeryAI, videoproductie',

        // Generator section
        generatorTitle: 'Google Veo 3 AI-videogenerator',
        generatorDescription: 'WeryAI heeft het model Veo 3 nu diep geïntegreerd, Het werd in mei 2025 gelanceerd op Google I/O 2025 en is een grote verbetering ten opzichte van Veo 2. Probeer Veo 3 gratis op de WeryAI-videogenerator!',
        
        // Tabs
        tabImageToVideo: 'Afbeelding naar video',
        tabTextToVideo: 'Tekst naar video',

        // Core features section
        coreFeaturesTitle: 'Kernfuncties van Veo 3',
        coreFeaturesSubtitle: 'Ontdek de kernfuncties van de Google Veo 3 AI-videogenerator en start een revolutionaire AI-videocreatiereis',

        // Native audio generation feature
        nativeAudioTitle: 'Native audiogeneratie',
        nativeAudioDescription: 'Veo 3 genereert audio en integreert dit in de video’s, voor perfecte audio-visuele synchronisatie en aantrekkelijkere, realistischere video’s.',

        // Reference video and consistent characters feature
        referenceVideoTitle: 'Referentievideo en consistente personages',
        referenceVideoDescription: 'Maak video’s met consistente personages op basis van referentiemateriaal, zodat uiterlijk en kenmerken in verschillende scènes consistent blijven.',

        // Camera control feature
        cameraControlTitle: 'Cameracontrole',
        cameraControlDescription: 'Maak video’s met specifieke camerabewegingen en ondersteun professionele lensbewegingen zoals push, pull, pan en tilt voor filmische effecten.',

        // Viral content creation feature
        viralContentTitle: 'Virale contentcreatie',
        viralContentDescription: 'Maak boeiende "fake news"-video’s of tijdreis-shorts om likes te winnen en makkelijk viraal te gaan op social media.',

        // Advanced prompt understanding feature
        advancedPromptTitle: 'Geavanceerd promptbegrip',
        advancedPromptDescription: 'Interpreteert complexe prompts nauwkeurig, begrijpt je creatieve intenties en zet tekst om in levendige visuele scènes.',

        // Precise style control feature
        preciseStyleControlTitle: 'Precieze stijlcontrole',
        preciseStyleControlDescription: 'Stuur de artistieke stijl met referentiebeelden en bereik nauwkeurige stijlcustomisatie die je creativiteit perfect presenteert.',

        // First and last frame feature
        firstLastFrameTitle: 'Eerste en laatste frame',
        firstLastFrameDescription: 'Genereer naadloze video’s tussen twee geüploade afbeeldingen met precieze scèneovergangen en vloeiende verbindingen.',

        // Add and remove objects feature
        addRemoveObjectsTitle: 'Objecten toevoegen en verwijderen',
        addRemoveObjectsDescription: 'Voeg objecten toe of verwijder ze in videoscènes voor flexibele bewerking en creatieve expressie.',

        // Flexible motion control feature
        flexibleMotionControlTitle: 'Flexibele bewegingscontrole',
        flexibleMotionControlDescription: 'Pas bewegingspaden van video-objecten aan en controleer animaties nauwkeurig voor unieke dynamische effecten.',

        // How to use section
        howToUseTitle: 'Zo gebruik je het',
        howToUseSubtitle: 'Drie eenvoudige stappen om te starten',
        step1Title: 'Selecteer model',
        step1Description: 'Kies het Veo 3-model in de AI-videotools',
        step2Title: 'Voer content in',
        step2Description: 'Voer prompts in of upload referentiebeelden',
        step3Title: 'Genereer video',
        step3Description: 'Klik op genereren, wacht en download je video',

        // YouTube videos section
        youtubeTitle: 'YouTube-video\'s over het Google Veo 3 AI-videomodel',
        youtubeVideosTitle: 'YouTube-video\'s over het Google Veo 3 AI-videomodel',
        youtubeVideoTitle: 'YouTube-video\'s over het Google Veo 3 AI-videomodel',

        // X Posts section
        xPostsTitle: 'X-berichten over het Veo 3 AI-videomodel',

        // Explore other models section
        exploreModelsTitle: 'Ontdek andere videomodellen',
        veoModelsTitle: 'Google Veo-modellen',
        veo2Title: 'Google Veo 2 AI-videogenerator',
        veo31Title: 'Google Veo 3.1 AI-videogenerator',
        veo3FastTitle: 'Google Veo 3 Fast AI-videogenerator',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        klingTitle: 'Kling 2.5 videogenerator',

        // FAQ section
        faqTitle: 'Veelgestelde vragen',

        // CTA section
        ctaTitle: 'Klaar om te starten?',
        ctaSubtitle: 'Probeer Veo 3 nu en zet je creativiteit om in geweldige video\'s',
        ctaDescription: 'Probeer Veo 3 nu en zet je creativiteit om in geweldige video\'s',
        ctaButton: 'Probeer Veo 3 op WeryAI',
        ctaNote: 'Geen creditcard vereist',
        ctaDisclaimer: 'Geen creditcard vereist',

        // Video playback related
        videoNotSupported: 'Je browser ondersteunt geen video-afspeling',
        videoUnsupported: 'Je browser ondersteunt geen video-afspeling',
        videoLoadingError: 'Video laden mislukt',
        videoLoadError: 'Video laden mislukt',
        videoReload: 'Opnieuw laden',
        },
    id: {
        // Page title and description
        pageTitle: 'Generator Video AI Google Veo 3 - Alat Pembuatan Video AI Revolusioner Gratis',
        pageDescription: 'Rasakan generator video AI Google Veo 3 dengan generasi audio native, video referensi, kontrol kamera, dan fitur inti. Coba gratis di WeryAI dan buat konten video AI profesional.',
        pageKeywords: 'Veo 3, generator video AI Google, pembuatan video AI, video kecerdasan buatan, alat generasi video, video AI gratis, WeryAI, produksi video',

        // Generator section
        generatorTitle: 'Generator Video AI Google Veo 3',
        generatorDescription: 'WeryAI kini telah mengintegrasikan model Veo 3 secara mendalam, Dirilis pada Mei 2025 di Google I/O 2025, ini merupakan peningkatan besar dari Veo 2. Coba Veo 3 gratis di generator video WeryAI!',
        
        // Tabs
        tabImageToVideo: 'Gambar ke Video',
        tabTextToVideo: 'Teks ke Video',

        // Core features section
        coreFeaturesTitle: 'Fitur Inti Veo 3',
        coreFeaturesSubtitle: 'Jelajahi fitur inti generator video AI Google Veo 3 dan mulai perjalanan pembuatan video AI yang revolusioner',

        // Native audio generation feature
        nativeAudioTitle: 'Generasi Audio Native',
        nativeAudioDescription: 'Veo 3 menghasilkan audio dan mengintegrasikannya ke video yang dibuat, menghasilkan sinkronisasi audio-visual yang sempurna sehingga video lebih menarik dan realistis.',

        // Reference video and consistent characters feature
        referenceVideoTitle: 'Video Referensi dan Karakter Konsisten',
        referenceVideoDescription: 'Buat video dengan karakter konsisten berdasarkan materi referensi, memastikan tampilan dan karakteristik tetap konsisten di berbagai adegan.',

        // Camera control feature
        cameraControlTitle: 'Kontrol Kamera',
        cameraControlDescription: 'Buat video dengan gerakan kamera tertentu, mendukung gerakan lensa profesional seperti push, pull, pan, dan tilt untuk efek sinematik.',

        // Viral content creation feature
        viralContentTitle: 'Pembuatan Konten Viral',
        viralContentDescription: 'Buat video "fake news" yang menarik atau video pendek time-travel untuk membantu Anda meraih like dan mudah viral di media sosial.',

        // Advanced prompt understanding feature
        advancedPromptTitle: 'Pemahaman Prompt Lanjutan',
        advancedPromptDescription: 'Menafsirkan prompt kompleks secara akurat, memahami niat kreatif Anda dengan tepat, dan mengubah deskripsi teks menjadi adegan visual yang hidup.',

        // Precise style control feature
        preciseStyleControlTitle: 'Kontrol Gaya Presisi',
        preciseStyleControlDescription: 'Kendalikan gaya artistik berdasarkan gambar referensi, mencapai kustomisasi gaya visual yang presisi untuk menampilkan kreativitas Anda secara sempurna.',

        // First and last frame feature
        firstLastFrameTitle: 'Frame Pertama dan Terakhir',
        firstLastFrameDescription: 'Hasilkan video mulus di antara dua gambar yang diunggah, menghasilkan transisi adegan yang presisi dan koneksi visual yang halus.',

        // Add and remove objects feature
        addRemoveObjectsTitle: 'Tambah dan Hapus Objek',
        addRemoveObjectsDescription: 'Tambah atau hapus objek di adegan video untuk pengeditan yang fleksibel dan ekspresi kreatif.',

        // Flexible motion control feature
        flexibleMotionControlTitle: 'Kontrol Gerak Fleksibel',
        flexibleMotionControlDescription: 'Sesuaikan jalur gerak objek video, kontrol animasi setiap elemen secara presisi, dan ciptakan efek dinamis yang unik.',

        // How to use section
        howToUseTitle: 'Cara Menggunakan',
        howToUseSubtitle: 'Tiga langkah sederhana untuk mulai',
        step1Title: 'Pilih Model',
        step1Description: 'Pilih model Veo 3 di alat video AI',
        step2Title: 'Masukkan Konten',
        step2Description: 'Masukkan prompt atau unggah gambar referensi',
        step3Title: 'Buat Video',
        step3Description: 'Klik tombol generate, tunggu, lalu unduh video Anda',

        // YouTube videos section
        youtubeTitle: 'Video YouTube tentang Model Video AI Google Veo 3',
        youtubeVideosTitle: 'Video YouTube tentang Model Video AI Google Veo 3',
        youtubeVideoTitle: 'Video YouTube tentang Model Video AI Google Veo 3',

        // X Posts section
        xPostsTitle: 'Posting X tentang Model Video AI Veo 3',

        // Explore other models section
        exploreModelsTitle: 'Jelajahi Model Video Lain',
        veoModelsTitle: 'Model Google Veo',
        veo2Title: 'Generator Video AI Google Veo 2',
        veo31Title: 'Generator Video AI Google Veo 3.1',
        veo3FastTitle: 'Generator Video AI Google Veo 3 Fast',
        sora2Title: 'Generator Video AI OpenAI Sora-2',
        klingTitle: 'Generator Video Kling 2.5',

        // FAQ section
        faqTitle: 'Pertanyaan yang Sering Diajukan',

        // CTA section
        ctaTitle: 'Siap mulai berkarya?',
        ctaSubtitle: 'Coba Veo 3 sekarang dan ubah kreativitas Anda menjadi video yang menakjubkan',
        ctaDescription: 'Coba Veo 3 sekarang dan ubah kreativitas Anda menjadi video yang menakjubkan',
        ctaButton: 'Coba Veo 3 di WeryAI',
        ctaNote: 'Tidak perlu kartu kredit',
        ctaDisclaimer: 'Tidak perlu kartu kredit',

        // Video playback related
        videoNotSupported: 'Browser Anda tidak mendukung pemutaran video',
        videoUnsupported: 'Browser Anda tidak mendukung pemutaran video',
        videoLoadingError: 'Gagal memuat video',
        videoLoadError: 'Gagal memuat video',
        videoReload: 'Muat ulang',
        },
    tr: {
        // Page title and description
        pageTitle: 'Google Veo 3 AI Video Üretici - Ücretsiz Devrimsel AI Video Aracı',
        pageDescription: 'Yerleşik ses üretimi, referans video, kamera kontrolü ve temel özellikleriyle Google Veo 3 AI video üreticisini deneyin. WeryAI’de ücretsiz deneyin ve profesyonel AI video içerikleri oluşturun.',
        pageKeywords: 'Veo 3, Google AI video üretici, AI video oluşturma, yapay zeka video, video üretim aracı, ücretsiz AI video, WeryAI, video prodüksiyon',

        // Generator section
        generatorTitle: 'Google Veo 3 AI Video Üretici',
        generatorDescription: 'WeryAI artık Veo 3 modelini derinlemesine entegre ediyor, yüksek kaliteli ve gerçekçi sesli video içerikleri üretebilen son teknoloji bir AI video modelidir. Mayıs 2025’te Google I/O 2025’te duyurulmuş ve Veo 2’ye göre önemli bir iyileştirme sunmuştur. Veo 3’ü WeryAI video üreticide ücretsiz deneyin!',
        
        // Tabs
        tabImageToVideo: 'Görselden Videoya',
        tabTextToVideo: 'Metinden Videoya',

        // Core features section
        coreFeaturesTitle: 'Veo 3 Temel Özellikler',
        coreFeaturesSubtitle: 'Google Veo 3 AI video üreticisinin temel özelliklerini keşfedin ve devrimsel bir AI video üretim yolculuğuna çıkın',

        // Native audio generation feature
        nativeAudioTitle: 'Yerleşik Ses Üretimi',
        nativeAudioDescription: 'Veo 3, ürettiği videolara sesi entegre eder ve mükemmel ses-görüntü senkronu sağlar; böylece videolarınız daha ilgi çekici ve gerçekçi olur.',

        // Reference video and consistent characters feature
        referenceVideoTitle: 'Referans Video ve Tutarlı Karakterler',
        referenceVideoDescription: 'Referans materyallere dayanarak karakter tutarlılığı olan videolar oluşturun; farklı sahnelerde karakter görünümü ve özellikleri yüksek tutarlılık sağlar.',

        // Camera control feature
        cameraControlTitle: 'Kamera Kontrolü',
        cameraControlDescription: 'Belirli kamera hareketleriyle videolar oluşturun; push, pull, pan ve tilt gibi profesyonel lens hareketlerini destekleyerek sinematik görseller üretin.',

        // Viral content creation feature
        viralContentTitle: 'Viral İçerik Üretimi',
        viralContentDescription: '“Sahte haber” videoları veya zaman yolculuğu kısa içerikleri üretin; beğeni kazanmanıza ve sosyal medyada kolayca viral olmanıza yardımcı olur.',

        // Advanced prompt understanding feature
        advancedPromptTitle: 'Gelişmiş Prompt Anlayışı',
        advancedPromptDescription: 'Karmaşık promptları doğru yorumlar, yaratıcı niyetinizi hassas biçimde anlar ve metin açıklamalarını canlı görsel sahnelere dönüştürür.',

        // Precise style control feature
        preciseStyleControlTitle: 'Hassas Stil Kontrolü',
        preciseStyleControlDescription: 'Referans görsellere göre sanatsal stili kontrol edin; görsel stili hassas biçimde özelleştirerek yaratıcılığınızı kusursuz biçimde yansıtın.',

        // First and last frame feature
        firstLastFrameTitle: 'İlk ve Son Kare',
        firstLastFrameDescription: 'Yüklenen iki görsel arasında kesintisiz videolar üretin; sahne geçişlerini hassas ve pürüzsüz yapın.',

        // Add and remove objects feature
        addRemoveObjectsTitle: 'Nesne Ekleme ve Kaldırma',
        addRemoveObjectsDescription: 'Video sahnelerine nesne ekleyip kaldırarak esnek sahne düzenleme ve yaratıcı ifade sağlayın.',

        // Flexible motion control feature
        flexibleMotionControlTitle: 'Esnek Hareket Kontrolü',
        flexibleMotionControlDescription: 'Video nesnelerinin hareket yollarını özelleştirin; her öğenin animasyonunu hassas kontrol ederek benzersiz dinamik efektler oluşturun.',

        // How to use section
        howToUseTitle: 'Nasıl Kullanılır',
        howToUseSubtitle: 'Başlamak için üç basit adım',
        step1Title: 'Model Seçin',
        step1Description: 'AI video araçlarında Veo 3 modelini seçin',
        step2Title: 'İçerik Girin',
        step2Description: 'Prompt girin veya referans görseller yükleyin',
        step3Title: 'Video Üretin',
        step3Description: 'Oluştur düğmesine tıklayın, bekleyin ve videonuzu indirin',

        // YouTube videos section
        youtubeTitle: 'Google Veo 3 AI Video Modeli Hakkında YouTube Videoları',
        youtubeVideosTitle: 'Google Veo 3 AI Video Modeli Hakkında YouTube Videoları',
        youtubeVideoTitle: 'Google Veo 3 AI Video Modeli Hakkında YouTube Videoları',

        // X Posts section
        xPostsTitle: 'Veo 3 AI Video Modeli Hakkında X Paylaşımları',

        // Explore other models section
        exploreModelsTitle: 'Diğer Video Modellerini Keşfedin',
        veoModelsTitle: 'Google Veo Modelleri',
        veo2Title: 'Google Veo 2 AI Video Üretici',
        veo31Title: 'Google Veo 3.1 AI Video Üretici',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Üretici',
        sora2Title: 'OpenAI Sora-2 AI Video Üretici',
        klingTitle: 'Kling 2.5 Video Üretici',

        // FAQ section
        faqTitle: 'Sıkça Sorulan Sorular',

        // CTA section
        ctaTitle: 'Oluşturmaya hazır mısınız?',
        ctaSubtitle: 'Veo 3’ü şimdi deneyin ve yaratıcılığınızı harika videolara dönüştürün',
        ctaDescription: 'Veo 3’ü şimdi deneyin ve yaratıcılığınızı harika videolara dönüştürün',
        ctaButton: 'WeryAI’de Veo 3’ü deneyin',
        ctaNote: 'Kredi kartı gerekmez',
        ctaDisclaimer: 'Kredi kartı gerekmez',

        // Video playback related
        videoNotSupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoUnsupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoLoadingError: 'Video yükleme başarısız',
        videoLoadError: 'Video yükleme başarısız',
        videoReload: 'Yeniden yükle',
    },
}
